import * as React from 'react';
export const LotsMapEs = ({ selectedLot, selectLot, sections }) => {
	console.log(selectedLot);
	let lotIdentifier = "";
	const handleSelect = (lotName) => {
		if (!sections) return;

		let allLots = [];
		const sectionLotMap = {};
		sections.forEach((section) => {
			allLots = [...allLots, ...section.lots];
			section.lots.forEach((lot) => {
				sectionLotMap[lot.location_name] = section;
			});
		});

		const clickedLot = allLots.find((lot) => lot.location_name === lotName);
		if (!clickedLot) return;

		const clickedSection = sectionLotMap[clickedLot.location_name];
		if (!clickedSection) return;

		selectLot(clickedSection.section, clickedLot);

	};
	if (selectedLot) {
		lotIdentifier = selectedLot.split(' ')[1];
	}
	return (
		<svg version="1.1" id="Layer_3" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
			viewBox="0 0 316.81 382.1" style={{ "enable-background": "new 0 0 316.81 382.1" }} >
			<style type="text/css">
				{`
	.st0{fill:#CFCFCE;}
	.st1{fill:#E13B95;}
	.st2{fill:#FFFFFF;}
	.st3{opacity:0.5;fill:#D1D3D4;}
	.st4{fill:#55436A;}
	.st5{fill:#FEFEFE;}
	.st6{fill:#F060A6;}
	.st7{fill:none;stroke:#BABCBE;stroke-width:0.5;stroke-miterlimit:10;}
	.st8{fill:#A199C3;}
	.st9{fill:#606161;}
	.st10{fill:#F498C0;}
	.st11{fill:#68A2B9;}
	.st12{fill:#EE8A38;}
	.st13{fill:#F05528;}
	.st14{fill:#31B5AF;}
	.st15{fill:#5ACAEA;}
	.st16{fill:#F5DF6C;}
	.st17{fill:#BBCC4D;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}
	.st18{fill:#319E52;}
	`}
			</style>
			<path onClick={() => { handleSelect('Lot A'); }} stroke={lotIdentifier === 'A' ? "#3F2B56" : "auto"} fill={lotIdentifier === 'A' ? "#90879D" : "#CFCFCE"} d="M235.85,110.7c0-6.05-5.71-16.31-18.47-22.84c-10.57-5.42-18.35-5.33-28.78-5.33
	c-10.79,0-41.82,9.75-41.82,34.4c0,13.12,0,55.59,0,55.59h89.07C235.85,172.51,235.85,116.75,235.85,110.7z"/>
			<g>
				<path class="st1" d="M203.42,144.88h-22.61c-4.18,0-7.57-3.39-7.57-7.57V122.9c0-4.18,3.39-7.57,7.57-7.57h22.61
		c4.18,0,7.57,3.39,7.57,7.57v14.41C210.98,141.49,207.6,144.88,203.42,144.88z"/>
				<g>
					<path class="st2" d="M180.14,123.72h-0.74v1.33h-0.97v-4.42h1.81c1.06,0,1.69,0.63,1.69,1.53v0.01
			C181.93,123.19,181.13,123.72,180.14,123.72z M180.94,122.17c0-0.44-0.3-0.67-0.79-0.67h-0.75v1.35h0.77
			c0.49,0,0.77-0.29,0.77-0.67V122.17z"/>
					<path class="st2" d="M184.89,125.05l-0.95-1.42h-0.76v1.42h-0.97v-4.42h2.02c1.04,0,1.67,0.55,1.67,1.46v0.01
			c0,0.71-0.38,1.16-0.95,1.37l1.08,1.58H184.89z M184.91,122.14c0-0.42-0.29-0.63-0.76-0.63h-0.97v1.27h0.99
			c0.47,0,0.75-0.25,0.75-0.62V122.14z"/>
					<path class="st2" d="M186.36,125.05v-4.42h3.34v0.87h-2.37v0.9h2.08v0.87h-2.08v0.93h2.4v0.87H186.36z" />
					<path class="st2" d="M193.68,125.05v-2.89l-1.25,1.89h-0.02l-1.23-1.87v2.87h-0.95v-4.42h1.05l1.16,1.87l1.16-1.87h1.05v4.42
			H193.68z"/>
					<path class="st2" d="M195.33,125.05v-4.42h0.97v4.42H195.33z" />
					<path class="st2" d="M198.84,125.12c-1.19,0-1.91-0.66-1.91-1.96v-2.53h0.97v2.5c0,0.72,0.36,1.09,0.95,1.09s0.95-0.36,0.95-1.06
			v-2.53h0.97v2.5C200.78,124.46,200.03,125.12,198.84,125.12z"/>
					<path class="st2" d="M204.85,125.05v-2.89l-1.25,1.89h-0.02l-1.23-1.87v2.87h-0.95v-4.42h1.05l1.16,1.87l1.16-1.87h1.05v4.42
			H204.85z"/>
				</g>
				<g>
					<path class="st2" d="M195.97,140.54l-1.18-2.89h-5.45l-1.18,2.89h-2.89l5.52-12.97h2.61l5.52,12.97H195.97z M192.06,130.97
			l-1.71,4.18h3.42L192.06,130.97z"/>
				</g>
			</g>
			<path class="st3" d="M258.98,363.11v-243.2c0-5.84-3.66-18.78-13.73-30.5c-8.76-10.19-25.07-22.33-53.03-22.33
	c-26.02,0-42.46,11.34-51.66,20.86c-10.2,10.54-16.79,24.69-16.79,36.04v239.12H0v18.99h316.81v-18.99H258.98z M135.77,123.99
	c0-13.21,16.24-44.9,56.45-44.9c44.55,0,54.76,35.47,54.76,40.82v243.2H135.77V123.99z"/>
			<polygon class="st4" points="312.33,35.27 288.29,63.18 312.15,100.81 298.69,110.07 300.22,111.82 282.8,122.95 259.59,88.02 
	255.63,82.96 237.55,102.03 224.05,90.33 242.74,70.13 232.59,58.83 212.72,41.4 224.4,28.74 226.03,29.95 239.15,14.65 
	248.62,21.55 263.6,36.46 286.4,11.69 "/>
			<g>
				<path class="st2" d="M252.05,69.14h-1.35v5.15h-1.24v-5.15h-1.35v-1.02h3.94V69.14z" />
				<path class="st2" d="M256.03,69.14h-2.2v1.45h2.07v1.02h-2.07v1.66h2.29v1.02h-3.54v-6.17h3.45V69.14z" />
				<path class="st2" d="M259.04,68.12c0.52,0,0.92,0.13,1.21,0.39c0.29,0.26,0.43,0.66,0.43,1.2c0,0.42-0.08,0.75-0.25,1.02
		s-0.43,0.43-0.78,0.51v0.02c0.31,0.05,0.54,0.15,0.68,0.3c0.14,0.16,0.23,0.41,0.27,0.75c0.01,0.12,0.02,0.24,0.03,0.38
		c0.01,0.14,0.01,0.29,0.02,0.45c0.01,0.33,0.03,0.58,0.05,0.75c0.03,0.17,0.11,0.29,0.22,0.35v0.05h-1.35
		c-0.06-0.09-0.1-0.19-0.12-0.3c-0.02-0.11-0.03-0.23-0.04-0.35l-0.03-1.18c-0.01-0.24-0.07-0.43-0.18-0.57s-0.29-0.21-0.55-0.21
		h-0.67v2.61h-1.25v-6.17H259.04z M258.5,70.82c0.3,0,0.53-0.07,0.69-0.21c0.16-0.14,0.24-0.38,0.24-0.71
		c0-0.57-0.29-0.86-0.86-0.86h-0.59v1.78H258.5z"/>
				<path class="st2" d="M263.42,68.12l0.88,4.36h0.02l0.89-4.36h1.84v6.17h-1.14v-4.93h-0.02l-1.1,4.93h-0.97l-1.1-4.93h-0.02v4.93
		h-1.14v-6.17H263.42z"/>
				<path class="st2" d="M268,68.12h1.25v6.17H268V68.12z" />
				<path class="st2" d="M273.1,72.35h0.02v-4.23h1.14v6.17h-1.42l-1.52-4.32h-0.02v4.32h-1.14v-6.17h1.43L273.1,72.35z" />
				<path class="st2" d="M277.86,68.12l1.63,6.17h-1.3l-0.29-1.3h-1.64l-0.29,1.3h-1.3l1.63-6.17H277.86z M277.7,71.97l-0.6-2.77h-0.02
		l-0.6,2.77H277.7z"/>
				<path class="st2" d="M279.93,68.12h1.25v5.15h2.2v1.02h-3.45V68.12z" />
			</g>
			<g>
				<path class="st5" d="M248.17,57.69L248.17,57.69c0-0.54,0.4-0.98,0.98-0.98c0.36,0,0.57,0.12,0.74,0.29l-0.26,0.3
		c-0.15-0.13-0.29-0.21-0.48-0.21c-0.32,0-0.55,0.26-0.55,0.59v0.01c0,0.32,0.22,0.59,0.55,0.59c0.22,0,0.35-0.09,0.5-0.22
		l0.26,0.27c-0.19,0.21-0.41,0.34-0.77,0.34C248.59,58.66,248.17,58.23,248.17,57.69"/>
				<path class="st5" d="M251.11,57.66c0.2,0,0.32-0.11,0.32-0.27v-0.01c0-0.18-0.12-0.27-0.33-0.27h-0.41v0.54H251.11z M250.27,56.75
		h0.86c0.24,0,0.42,0.07,0.55,0.19c0.11,0.11,0.16,0.25,0.16,0.43v0.01c0,0.3-0.16,0.5-0.4,0.58l0.46,0.67h-0.48l-0.4-0.6h-0.33v0.6
		h-0.41V56.75z"/>
				<path class="st5" d="M253.73,57.69L253.73,57.69c0-0.33-0.24-0.6-0.57-0.6c-0.33,0-0.57,0.26-0.57,0.59v0.01
		c0,0.32,0.24,0.59,0.57,0.59C253.5,58.28,253.73,58.02,253.73,57.69 M252.16,57.69L252.16,57.69c0-0.54,0.42-0.98,1-0.98
		c0.58,0,1,0.43,1,0.97v0.01c0,0.54-0.42,0.97-1,0.97C252.58,58.66,252.16,58.23,252.16,57.69"/>
				<path class="st5" d="M254.42,58.36l0.24-0.29c0.17,0.14,0.35,0.23,0.56,0.23c0.17,0,0.27-0.07,0.27-0.18v-0.01
		c0-0.11-0.06-0.16-0.38-0.24c-0.38-0.1-0.62-0.2-0.62-0.58v-0.01c0-0.34,0.27-0.57,0.66-0.57c0.27,0,0.51,0.09,0.7,0.24l-0.22,0.31
		c-0.17-0.12-0.33-0.19-0.49-0.19c-0.16,0-0.24,0.07-0.24,0.16v0.01c0,0.12,0.08,0.16,0.41,0.25c0.38,0.1,0.6,0.24,0.6,0.57v0.01
		c0,0.37-0.29,0.58-0.69,0.58C254.94,58.66,254.65,58.56,254.42,58.36"/>
				<path class="st5" d="M256.14,58.36l0.24-0.29c0.17,0.14,0.35,0.23,0.56,0.23c0.17,0,0.27-0.07,0.27-0.18v-0.01
		c0-0.11-0.06-0.16-0.38-0.24c-0.38-0.1-0.62-0.2-0.62-0.58v-0.01c0-0.34,0.27-0.57,0.66-0.57c0.27,0,0.51,0.09,0.7,0.24l-0.22,0.31
		c-0.17-0.12-0.33-0.19-0.49-0.19s-0.24,0.07-0.24,0.16v0.01c0,0.12,0.08,0.16,0.41,0.25c0.38,0.1,0.6,0.24,0.6,0.57v0.01
		c0,0.37-0.29,0.58-0.69,0.58C256.66,58.66,256.37,58.56,256.14,58.36"/>
				<path class="st5" d="M259.74,57.85h-0.48v0.41h0.49c0.18,0,0.29-0.06,0.29-0.2v-0.01C260.05,57.93,259.96,57.85,259.74,57.85
		 M259.95,57.3c0-0.12-0.1-0.19-0.27-0.19h-0.41v0.4h0.38C259.83,57.51,259.95,57.45,259.95,57.3L259.95,57.3z M258.86,56.75h0.87
		c0.22,0,0.38,0.06,0.49,0.17c0.09,0.09,0.13,0.19,0.13,0.32v0.01c0,0.21-0.11,0.33-0.25,0.41c0.22,0.08,0.35,0.21,0.35,0.46v0.01
		c0,0.34-0.28,0.52-0.71,0.52h-0.9V56.75z"/>
				<path class="st5" d="M262.32,57.69L262.32,57.69c0-0.33-0.24-0.6-0.57-0.6c-0.33,0-0.57,0.26-0.57,0.59v0.01
		c0,0.32,0.24,0.59,0.57,0.59C262.09,58.28,262.32,58.02,262.32,57.69 M260.75,57.69L260.75,57.69c0-0.54,0.42-0.98,1-0.98
		c0.58,0,1,0.43,1,0.97v0.01c0,0.54-0.42,0.97-1,0.97C261.17,58.66,260.75,58.23,260.75,57.69"/>
				<path class="st5" d="M263.98,57.66c0.2,0,0.32-0.11,0.32-0.27v-0.01c0-0.18-0.12-0.27-0.33-0.27h-0.41v0.54H263.98z M263.15,56.75
		h0.86c0.24,0,0.43,0.07,0.55,0.19c0.11,0.11,0.16,0.25,0.16,0.43v0.01c0,0.3-0.16,0.5-0.4,0.58l0.46,0.67h-0.48l-0.4-0.6h-0.33v0.6
		h-0.41V56.75z"/>
				<path class="st5" d="M265.54,57.12v1.14h0.32c0.34,0,0.57-0.23,0.57-0.56v-0.01c0-0.33-0.23-0.57-0.57-0.57H265.54z M265.12,56.75
		h0.73c0.59,0,1,0.41,1,0.94v0.01c0,0.53-0.41,0.94-1,0.94h-0.73V56.75z"/>
				<polygon class="st5" points="267.26,56.75 268.68,56.75 268.68,57.12 267.67,57.12 267.67,57.5 268.56,57.5 268.56,57.87 
		267.67,57.87 267.67,58.26 268.69,58.26 268.69,58.63 267.26,58.63 	"/>
				<path class="st5" d="M269.92,57.66c0.2,0,0.32-0.11,0.32-0.27v-0.01c0-0.18-0.12-0.27-0.33-0.27h-0.41v0.54H269.92z M269.09,56.75
		h0.86c0.24,0,0.43,0.07,0.55,0.19c0.1,0.11,0.16,0.25,0.16,0.43v0.01c0,0.3-0.16,0.5-0.4,0.58l0.46,0.67h-0.48l-0.4-0.6h-0.33v0.6
		h-0.41V56.75z"/>
				<polygon class="st5" points="273.53,56.75 272.9,57.67 273.56,58.63 273.08,58.63 272.65,57.98 272.23,58.63 271.76,58.63 
		272.41,57.67 271.78,56.75 272.27,56.75 272.66,57.36 273.06,56.75 	"/>
				<path class="st5" d="M274.64,57.7c0.21,0,0.33-0.12,0.33-0.29v-0.01c0-0.19-0.13-0.29-0.34-0.29h-0.32v0.58H274.64z M273.9,56.75
		h0.77c0.45,0,0.72,0.27,0.72,0.65v0.01c0,0.44-0.34,0.66-0.76,0.66h-0.32v0.57h-0.41V56.75z"/>
				<path class="st5" d="M276.56,57.66c0.2,0,0.32-0.11,0.32-0.27v-0.01c0-0.18-0.12-0.27-0.33-0.27h-0.41v0.54H276.56z M275.72,56.75
		h0.86c0.24,0,0.43,0.07,0.55,0.19c0.1,0.11,0.16,0.25,0.16,0.43v0.01c0,0.3-0.16,0.5-0.4,0.58l0.46,0.67h-0.48l-0.4-0.6h-0.33v0.6
		h-0.41V56.75z"/>
				<polygon class="st5" points="277.7,56.75 279.12,56.75 279.12,57.12 278.11,57.12 278.11,57.5 278.99,57.5 278.99,57.87 
		278.11,57.87 278.11,58.26 279.13,58.26 279.13,58.63 277.7,58.63 	"/>
				<path class="st5" d="M279.4,58.36l0.24-0.29c0.17,0.14,0.35,0.23,0.56,0.23c0.17,0,0.27-0.07,0.27-0.18v-0.01
		c0-0.11-0.06-0.16-0.38-0.24c-0.38-0.1-0.62-0.2-0.62-0.58v-0.01c0-0.34,0.27-0.57,0.66-0.57c0.27,0,0.51,0.09,0.7,0.24l-0.22,0.31
		c-0.17-0.12-0.33-0.19-0.49-0.19c-0.16,0-0.24,0.07-0.24,0.16v0.01c0,0.12,0.08,0.16,0.41,0.25c0.38,0.1,0.6,0.24,0.6,0.57v0.01
		c0,0.37-0.28,0.58-0.69,0.58C279.91,58.66,279.62,58.56,279.4,58.36"/>
				<path class="st5" d="M281.12,58.36l0.24-0.29c0.17,0.14,0.35,0.23,0.56,0.23c0.17,0,0.27-0.07,0.27-0.18v-0.01
		c0-0.11-0.06-0.16-0.38-0.24c-0.38-0.1-0.62-0.2-0.62-0.58v-0.01c0-0.34,0.27-0.57,0.66-0.57c0.27,0,0.51,0.09,0.7,0.24l-0.22,0.31
		c-0.17-0.12-0.33-0.19-0.49-0.19c-0.16,0-0.24,0.07-0.24,0.16v0.01c0,0.12,0.08,0.16,0.41,0.25c0.38,0.1,0.6,0.24,0.6,0.57v0.01
		c0,0.37-0.29,0.58-0.69,0.58C281.63,58.66,281.35,58.56,281.12,58.36"/>
				<polygon class="st5" points="282.88,56.81 282.8,56.81 282.8,56.75 283.02,56.75 283.02,56.81 282.94,56.81 282.94,57.02 
		282.88,57.02 	"/>
				<polygon class="st5" points="283.06,56.75 283.12,56.75 283.19,56.87 283.26,56.75 283.33,56.75 283.33,57.02 283.27,57.02 
		283.27,56.85 283.19,56.96 283.19,56.96 283.12,56.85 283.12,57.02 283.06,57.02 	"/>
				<path class="st5" d="M260.57,51.58l-1.35-1.39c-0.76,0.7-1.43,1.15-2.53,1.15c-1.65,0-2.79-1.4-2.79-3.08v-0.03
		c0-1.68,1.17-3.06,2.79-3.06c0.96,0,1.72,0.42,2.46,1.11l1.35-1.58c-0.89-0.9-1.98-1.51-3.79-1.51c-2.96,0-5.02,2.29-5.02,5.08
		v0.03c0,2.37,1.49,4.32,3.66,4.88c1.38-0.31,2.84-0.57,4.33-0.77C259.99,52.16,260.29,51.89,260.57,51.58"/>
				<path class="st5" d="M266.26,51.27h-2.51v-2.16h2.45c1.09,0,1.57,0.41,1.57,1.07v0.03C267.76,50.93,267.2,51.27,266.26,51.27
		 M263.75,45.24h2.09c0.89,0,1.39,0.36,1.39,1.01v0.03c0,0.73-0.59,1.04-1.53,1.04h-1.95V45.24z M269.41,51.79
		c0.27-0.19,1.04-2.99-1.28-3.59c0.69-0.39,1.2-1.18,1.2-2.29v-0.03c0-0.67-0.22-1.22-0.66-1.67c-0.55-0.56-1.42-0.87-2.52-0.87
		h-4.47v8.8C264.25,51.87,266.8,51.74,269.41,51.79"/>
				<path class="st5" d="M273.18,52.01l1.43-2.21l1.67,2.6c1.02,0.17,1.98,0.37,2.85,0.59l-3.23-4.77l3.22-4.86h-2.41l-2.05,3.18
		l-2.01-3.18h-2.47l3.22,4.89l-2.48,3.62c0.39,0.02,0.77,0.04,1.16,0.06C272.44,51.94,272.81,51.98,273.18,52.01"/>
				<path class="st6" d="M282.55,54.84c-12.13-4.78-29.25-1.02-34.31,1.05h6.14C258.9,54.66,271.41,53,282.55,54.84" />
			</g>
			<path class="st7" d="M316.57,142.03V22.43c0-13.8-12.48-24.24-26.06-21.81L0.32,52.43v178.36" />
			<rect x="69.83" y="170.04" onClick={() => { handleSelect('Lot H'); }} stroke={lotIdentifier === 'H' ? "#3F2B56" : "auto"} fill={lotIdentifier === 'H' ? "#90879D" : "#CFCFCE"} width="50.41" height="71.64" />
			<rect x="69.83" y="256.59" onClick={() => { handleSelect('Lot G'); }} stroke={lotIdentifier === 'G' ? "#3F2B56" : "auto"} fill={lotIdentifier === 'G' ? "#90879D" : "#CFCFCE"} width="50.41" height="102.22" />
			<polygon onClick={() => { handleSelect('Lot J'); }} stroke={lotIdentifier === 'J' ? "#3F2B56" : "auto"} fill={lotIdentifier === 'J' ? "#90879D" : "#CFCFCE"} points="48,149.44 66.83,149.44 66.83,358.81 0,358.81 0,230.2 9.71,230.2 29.9,183.61 48,165.28 " />
			<path onClick={() => { handleSelect('Lot B'); }} stroke={lotIdentifier === 'B' ? "#3F2B56" : "auto"} fill={lotIdentifier === 'B' ? "#90879D" : "#CFCFCE"} d="M141.48,81.5V68.7H69.78v78.37h50.41v-28.22C120.19,96.78,141.48,81.5,141.48,81.5z" />
			<g>
				<path class="st8" d="M106.94,122.26H84.33c-4.18,0-7.57-3.39-7.57-7.57v-14.41c0-4.18,3.39-7.57,7.57-7.57h22.61
		c4.18,0,7.57,3.39,7.57,7.57v14.41C114.51,118.87,111.12,122.26,106.94,122.26z"/>
				<g>
					<path class="st2" d="M83.57,101.1h-0.74v1.33h-0.97v-4.42h1.81c1.06,0,1.69,0.63,1.69,1.53v0.01
			C85.36,100.57,84.56,101.1,83.57,101.1z M84.37,99.56c0-0.44-0.3-0.67-0.79-0.67h-0.75v1.35h0.77c0.49,0,0.77-0.29,0.77-0.67
			V99.56z"/>
					<path class="st2" d="M88.32,102.43l-0.95-1.42h-0.76v1.42h-0.97v-4.42h2.02c1.04,0,1.67,0.55,1.67,1.46v0.01
			c0,0.71-0.38,1.16-0.95,1.37l1.08,1.58H88.32z M88.34,99.52c0-0.42-0.29-0.63-0.76-0.63h-0.97v1.27h0.99
			c0.47,0,0.75-0.25,0.75-0.62V99.52z"/>
					<path class="st2" d="M89.8,102.43v-4.42h3.34v0.87h-2.37v0.9h2.08v0.87h-2.08v0.93h2.4v0.87H89.8z" />
					<path class="st2" d="M97.11,102.43v-2.89l-1.25,1.89h-0.02l-1.23-1.87v2.87h-0.95v-4.42h1.05l1.16,1.87l1.16-1.87h1.05v4.42H97.11
			z"/>
					<path class="st2" d="M98.76,102.43v-4.42h0.97v4.42H98.76z" />
					<path class="st2" d="M102.27,102.5c-1.19,0-1.91-0.66-1.91-1.96v-2.53h0.97v2.5c0,0.72,0.36,1.09,0.95,1.09s0.95-0.36,0.95-1.06
			v-2.53h0.97v2.5C104.21,101.84,103.46,102.5,102.27,102.5z"/>
					<path class="st2" d="M108.28,102.43v-2.89l-1.25,1.89h-0.02l-1.23-1.87v2.87h-0.95v-4.42h1.05l1.16,1.87l1.16-1.87h1.05v4.42
			H108.28z"/>
				</g>
				<g>
					<path class="st2" d="M96.72,117.92h-6.13v-12.88h5.98c2.63,0,4.25,1.31,4.25,3.33v0.04c0,1.45-0.77,2.26-1.69,2.78
			c1.49,0.57,2.41,1.44,2.41,3.17v0.04C101.54,116.74,99.63,117.92,96.72,117.92z M98.01,108.85c0-0.85-0.66-1.32-1.86-1.32h-2.8
			v2.72h2.61c1.25,0,2.04-0.4,2.04-1.36V108.85z M98.73,114c0-0.87-0.64-1.4-2.1-1.4h-3.28v2.83h3.37c1.25,0,2.01-0.44,2.01-1.4V114
			z"/>
				</g>
			</g>
			<rect x="261.7" y="136.18" onClick={() => { handleSelect('Lot D'); }} stroke={lotIdentifier === 'D' ? "#3F2B56" : "auto"} fill={lotIdentifier === 'D' ? "#90879D" : "#CFCFCE"} width="55.14" height="116.8" />
			<rect x="261.67" y="260.21" onClick={() => { handleSelect('Lot C'); }} stroke={lotIdentifier === 'C' ? "#3F2B56" : "auto"} fill={lotIdentifier === 'C' ? "#90879D" : "#CFCFCE"} width="55.14" height="98.62" />
			<rect x="146.69" y="208.94" onClick={() => { handleSelect('Lot F'); }} stroke={lotIdentifier === 'F' ? "#3F2B56" : "auto"} fill={lotIdentifier === 'F' ? "#90879D" : "#CFCFCE"} width="89.08" height="44.04" />
			<rect x="146.69" y="256.59" onClick={() => { handleSelect('Lot E'); }} stroke={lotIdentifier === 'E' ? "#3F2B56" : "auto"} fill={lotIdentifier === 'E' ? "#90879D" : "#CFCFCE"} width="89.08" height="102.24" />
			<g>
				<rect x="253.95" y="372.05" class="st9" width="4.18" height="0.81" />
				<rect x="272.5" y="372.05" class="st9" width="4.18" height="0.81" />
				<rect x="235.45" y="372.05" class="st9" width="4.18" height="0.81" />
				<rect x="291.05" y="372.05" class="st9" width="4.18" height="0.81" />
				<rect x="309.6" y="372.05" class="st9" width="4.18" height="0.81" />
				<rect x="28.29" y="372.05" class="st9" width="4.18" height="0.81" />
				<rect x="46.85" y="372.05" class="st9" width="4.18" height="0.81" />
				<rect x="9.86" y="372.05" class="st9" width="4.18" height="0.81" />
				<rect x="65.4" y="372.05" class="st9" width="4.18" height="0.81" />
				<rect x="83.95" y="372.05" class="st9" width="4.18" height="0.81" />
				<g>
					<path class="st9" d="M114.76,369.49c-0.18-0.25-0.41-0.45-0.69-0.61c-0.28-0.15-0.62-0.23-1.02-0.23c-0.2,0-0.41,0.03-0.62,0.09
			c-0.21,0.06-0.4,0.16-0.58,0.29c-0.17,0.13-0.31,0.29-0.42,0.49c-0.11,0.2-0.16,0.43-0.16,0.69s0.05,0.49,0.15,0.66
			c0.1,0.17,0.24,0.32,0.41,0.44c0.17,0.12,0.36,0.22,0.58,0.3c0.22,0.08,0.44,0.16,0.68,0.24c0.29,0.09,0.58,0.2,0.88,0.31
			c0.29,0.11,0.56,0.25,0.79,0.43c0.23,0.18,0.43,0.4,0.58,0.67c0.15,0.27,0.22,0.62,0.22,1.03c0,0.42-0.08,0.78-0.24,1.08
			c-0.16,0.3-0.36,0.55-0.62,0.75c-0.25,0.2-0.54,0.34-0.87,0.44c-0.33,0.09-0.65,0.14-0.98,0.14c-0.25,0-0.5-0.03-0.75-0.08
			c-0.25-0.05-0.49-0.13-0.72-0.23c-0.23-0.1-0.44-0.23-0.64-0.39c-0.2-0.16-0.37-0.34-0.52-0.54l0.73-0.54
			c0.18,0.3,0.43,0.55,0.76,0.75c0.33,0.2,0.71,0.3,1.15,0.3c0.21,0,0.43-0.03,0.65-0.1c0.22-0.07,0.42-0.17,0.59-0.31
			c0.18-0.14,0.32-0.31,0.44-0.51c0.11-0.2,0.17-0.43,0.17-0.7c0-0.29-0.06-0.53-0.17-0.72c-0.11-0.19-0.27-0.35-0.45-0.48
			c-0.19-0.13-0.4-0.24-0.65-0.32c-0.24-0.09-0.5-0.17-0.77-0.26c-0.28-0.09-0.55-0.18-0.81-0.29c-0.27-0.11-0.51-0.25-0.72-0.43
			c-0.21-0.18-0.38-0.39-0.51-0.65c-0.13-0.26-0.19-0.58-0.19-0.95c0-0.4,0.08-0.75,0.24-1.04c0.16-0.29,0.37-0.53,0.63-0.72
			c0.26-0.19,0.55-0.33,0.86-0.41c0.31-0.09,0.62-0.13,0.93-0.13c0.57,0,1.05,0.1,1.45,0.3c0.4,0.2,0.7,0.44,0.91,0.71
			L114.76,369.49z"/>
					<path class="st9" d="M118.71,376.49h-0.85v-8.34h0.85V376.49z" />
					<path class="st9" d="M122.36,375.73h4.47v0.75h-5.31v-8.34h5.17v0.75h-4.32v2.86h4.04v0.75h-4.04V375.73z" />
					<path class="st9" d="M133.04,375.05h0.01l2.79-6.9h1.3v8.34h-0.85v-7.25h-0.02l-3.02,7.25h-0.45l-3.02-7.25h-0.02v7.25h-0.85
			v-8.34h1.3L133.04,375.05z"/>
					<path class="st9" d="M139.95,368.14h2.36c0.42,0,0.81,0.05,1.15,0.14c0.35,0.09,0.64,0.23,0.89,0.41c0.25,0.18,0.44,0.42,0.57,0.7
			c0.13,0.28,0.2,0.61,0.2,0.98s-0.07,0.71-0.21,0.98c-0.14,0.28-0.33,0.51-0.58,0.69c-0.25,0.18-0.55,0.32-0.9,0.42
			c-0.35,0.09-0.74,0.14-1.16,0.14h-1.48v3.88h-0.85V368.14z M140.8,371.89h1.44c0.67,0,1.17-0.13,1.52-0.39
			c0.35-0.26,0.52-0.64,0.52-1.13c0-0.52-0.18-0.9-0.54-1.14c-0.36-0.24-0.86-0.36-1.5-0.36h-1.44V371.89z"/>
					<path class="st9" d="M148.04,376.49h-0.85v-8.34h2.45c0.41,0,0.79,0.04,1.14,0.12c0.35,0.08,0.65,0.21,0.91,0.38
			c0.25,0.18,0.45,0.41,0.59,0.69c0.14,0.28,0.21,0.63,0.21,1.04c0,0.31-0.05,0.59-0.16,0.84c-0.11,0.25-0.26,0.47-0.45,0.65
			c-0.19,0.18-0.41,0.33-0.67,0.44c-0.26,0.11-0.54,0.18-0.85,0.21l2.44,3.97h-1.04l-2.31-3.9h-1.41V376.49z M148.04,371.86h1.47
			c0.68,0,1.21-0.12,1.58-0.37c0.37-0.25,0.55-0.62,0.55-1.11c0-0.27-0.05-0.51-0.15-0.69c-0.1-0.19-0.24-0.34-0.42-0.46
			c-0.18-0.12-0.4-0.2-0.66-0.26c-0.26-0.05-0.55-0.08-0.86-0.08h-1.51V371.86z"/>
					<path class="st9" d="M155.7,375.73h4.47v0.75h-5.31v-8.34h5.17v0.75h-4.32v2.86h4.04v0.75h-4.04V375.73z" />
					<path class="st9" d="M168.51,375.39h0.02l2.71-7.25h0.91l-3.19,8.34h-0.9l-3.18-8.34h0.92L168.51,375.39z" />
					<path class="st9" d="M174.8,376.49h-0.85v-8.34h0.85V376.49z" />
					<path class="st9" d="M180.24,375.39h0.02l2.71-7.25h0.91l-3.19,8.34h-0.9l-3.18-8.34h0.92L180.24,375.39z" />
					<path class="st9" d="M184.92,376.49h-0.93l3.61-8.34h0.82l3.58,8.34h-0.94l-0.92-2.19h-4.31L184.92,376.49z M186.15,373.52h3.68
			l-1.84-4.43L186.15,373.52z"/>
					<path class="st9" d="M198.2,376.49h-0.85v-8.34h2.45c0.41,0,0.79,0.04,1.14,0.12c0.35,0.08,0.65,0.21,0.91,0.38
			c0.26,0.18,0.45,0.41,0.6,0.69c0.14,0.28,0.21,0.63,0.21,1.04c0,0.31-0.05,0.59-0.16,0.84c-0.11,0.25-0.26,0.47-0.45,0.65
			c-0.19,0.18-0.41,0.33-0.67,0.44c-0.26,0.11-0.54,0.18-0.85,0.21l2.44,3.97h-1.04l-2.31-3.9h-1.41V376.49z M198.2,371.86h1.47
			c0.68,0,1.21-0.12,1.58-0.37c0.37-0.25,0.55-0.62,0.55-1.11c0-0.27-0.05-0.51-0.15-0.69c-0.1-0.19-0.24-0.34-0.42-0.46
			c-0.18-0.12-0.4-0.2-0.66-0.26c-0.26-0.05-0.55-0.08-0.86-0.08h-1.51V371.86z"/>
					<path class="st9" d="M205.02,368.14h2.77c0.52,0,1.04,0.09,1.56,0.26c0.52,0.17,0.99,0.43,1.41,0.78
			c0.42,0.35,0.76,0.79,1.02,1.31c0.26,0.52,0.39,1.13,0.39,1.82c0,0.7-0.13,1.31-0.39,1.83c-0.26,0.52-0.6,0.95-1.02,1.3
			c-0.42,0.35-0.89,0.61-1.41,0.78c-0.52,0.17-1.04,0.26-1.56,0.26h-2.77V368.14z M205.87,375.73h1.68c0.63,0,1.18-0.1,1.64-0.29
			c0.47-0.2,0.85-0.45,1.16-0.77c0.31-0.32,0.54-0.68,0.69-1.09c0.15-0.41,0.23-0.83,0.23-1.26c0-0.43-0.08-0.85-0.23-1.26
			c-0.15-0.41-0.38-0.77-0.69-1.09c-0.31-0.32-0.69-0.58-1.16-0.77c-0.47-0.2-1.02-0.3-1.64-0.3h-1.68V375.73z"/>
					<path class="st9" d="M215.11,375.92c0,0.16-0.06,0.31-0.18,0.44c-0.12,0.13-0.27,0.19-0.46,0.19c-0.19,0-0.34-0.06-0.46-0.19
			c-0.12-0.13-0.18-0.28-0.18-0.44c0-0.16,0.06-0.31,0.18-0.44c0.12-0.13,0.27-0.2,0.46-0.2c0.19,0,0.34,0.06,0.46,0.2
			C215.05,375.61,215.11,375.76,215.11,375.92z"/>
				</g>
			</g>
			<g>
				<path class="st10" d="M198.21,172.51c0,6.15,0,10.05,0,10.05h37.63c0,0,0-3.81,0-10.05H198.21z" />
				<path class="st10" d="M146.77,172.51c0,6.15,0,10.05,0,10.05h39.37c0,0,0-3.81,0-10.05H146.77z" />
				<path class="st10" d="M145.54,199.37c0,8.21,0,9.57,0,9.57h91.53c0,0,0-1.24,0-9.57H145.54z" />
				<path class="st10" d="M138.82,358.83c4.11,0,7.95,0,7.95,0V199.37c0,0-3.79,0-7.95,0V358.83z" />
				<path class="st10" d="M235.85,358.83c4.11,0,7.95,0,7.95,0v-51.69c0,0-3.79,0-7.95,0V358.83z" />
				<path class="st10" d="M235.85,296.79c4.11,0,7.95,0,7.95,0v-19.74c0,0-3.79,0-7.95,0V296.79z" />
				<path class="st10" d="M235.85,266.7c4.11,0,7.95,0,7.95,0v-33.15c0,0-3.79,0-7.95,0V266.7z" />
				<path class="st10" d="M235.85,221.86c4.11,0,7.95,0,7.95,0v-22.49c0,0-3.79,0-7.95,0V221.86z" />
			</g>
			<g>
				<path class="st2" d="M152.52,202.76h-1.86v1.22h1.75v0.86h-1.75v1.4h1.93v0.86h-2.98v-5.2h2.91V202.76z" />
				<path class="st2" d="M153.96,205.63c0,0.12,0.01,0.23,0.03,0.33s0.06,0.18,0.11,0.25c0.05,0.07,0.12,0.12,0.21,0.16
		s0.2,0.06,0.34,0.06c0.16,0,0.3-0.05,0.43-0.16c0.13-0.1,0.19-0.27,0.19-0.48c0-0.12-0.02-0.22-0.05-0.3
		c-0.03-0.08-0.08-0.16-0.16-0.23s-0.17-0.13-0.29-0.19c-0.12-0.06-0.27-0.11-0.44-0.17c-0.23-0.08-0.43-0.16-0.6-0.26
		s-0.31-0.2-0.43-0.32c-0.11-0.12-0.2-0.27-0.25-0.43s-0.08-0.35-0.08-0.56c0-0.51,0.14-0.9,0.43-1.15
		c0.29-0.25,0.68-0.38,1.18-0.38c0.23,0,0.45,0.03,0.64,0.08c0.2,0.05,0.37,0.13,0.51,0.25s0.25,0.26,0.33,0.44
		c0.08,0.18,0.12,0.39,0.12,0.64v0.15h-1.01c0-0.25-0.04-0.44-0.13-0.57c-0.09-0.13-0.23-0.2-0.44-0.2c-0.12,0-0.21,0.02-0.29,0.05
		c-0.08,0.03-0.14,0.08-0.19,0.13s-0.08,0.12-0.09,0.19c-0.02,0.07-0.03,0.15-0.03,0.23c0,0.16,0.03,0.29,0.1,0.4
		c0.07,0.11,0.21,0.21,0.44,0.3l0.81,0.35c0.2,0.09,0.36,0.18,0.49,0.27c0.13,0.09,0.23,0.2,0.3,0.31s0.13,0.23,0.16,0.36
		c0.03,0.13,0.04,0.28,0.04,0.44c0,0.55-0.16,0.95-0.48,1.2c-0.32,0.25-0.76,0.38-1.33,0.38c-0.59,0-1.02-0.13-1.27-0.39
		c-0.25-0.26-0.38-0.63-0.38-1.11v-0.21h1.05V205.63z"/>
				<path class="st2" d="M159.94,202.76h-1.14v4.34h-1.05v-4.34h-1.14v-0.86h3.32V202.76z" />
				<path class="st2" d="M162.3,201.9l1.38,5.2h-1.09l-0.24-1.1h-1.38l-0.24,1.1h-1.09l1.38-5.2H162.3z M162.16,205.15l-0.5-2.34h-0.01
		l-0.5,2.34H162.16z"/>
				<path class="st2" d="M166.13,202.83c-0.09-0.17-0.25-0.26-0.49-0.26c-0.13,0-0.24,0.04-0.32,0.11s-0.15,0.18-0.2,0.34
		c-0.05,0.16-0.08,0.36-0.1,0.62c-0.02,0.25-0.03,0.57-0.03,0.94c0,0.39,0.01,0.71,0.04,0.95c0.03,0.24,0.07,0.43,0.12,0.56
		c0.06,0.13,0.13,0.22,0.21,0.27c0.08,0.05,0.18,0.07,0.29,0.07c0.09,0,0.18-0.02,0.26-0.05c0.08-0.03,0.15-0.09,0.21-0.19
		c0.06-0.09,0.1-0.23,0.14-0.4c0.03-0.17,0.05-0.4,0.05-0.68h1.05c0,0.28-0.02,0.55-0.07,0.8c-0.04,0.25-0.12,0.47-0.24,0.66
		s-0.29,0.34-0.5,0.44s-0.5,0.16-0.84,0.16c-0.39,0-0.71-0.06-0.94-0.19c-0.23-0.13-0.41-0.31-0.54-0.55
		c-0.12-0.24-0.2-0.52-0.24-0.85c-0.04-0.33-0.05-0.69-0.05-1.09c0-0.39,0.02-0.76,0.05-1.09s0.12-0.62,0.24-0.86
		c0.12-0.24,0.3-0.42,0.54-0.56c0.23-0.13,0.55-0.2,0.94-0.2c0.37,0,0.67,0.06,0.89,0.18c0.22,0.12,0.38,0.28,0.48,0.46
		c0.11,0.19,0.17,0.39,0.2,0.6s0.04,0.42,0.04,0.61h-1.05C166.27,203.28,166.22,203,166.13,202.83z"/>
				<path class="st2" d="M168.01,201.9h1.05v5.2h-1.05V201.9z" />
				<path class="st2" d="M169.78,203.42c0.04-0.33,0.12-0.62,0.24-0.86c0.12-0.24,0.3-0.42,0.54-0.56c0.23-0.13,0.55-0.2,0.94-0.2
		s0.71,0.07,0.94,0.2c0.23,0.13,0.41,0.32,0.54,0.56c0.12,0.24,0.2,0.52,0.24,0.86c0.04,0.33,0.05,0.7,0.05,1.09
		c0,0.4-0.02,0.76-0.05,1.09c-0.04,0.33-0.12,0.61-0.24,0.85c-0.12,0.24-0.3,0.42-0.54,0.55c-0.23,0.13-0.55,0.19-0.94,0.19
		s-0.71-0.06-0.94-0.19c-0.23-0.13-0.41-0.31-0.54-0.55c-0.12-0.24-0.2-0.52-0.24-0.85c-0.04-0.33-0.05-0.69-0.05-1.09
		C169.73,204.11,169.74,203.75,169.78,203.42z M170.8,205.4c0.02,0.25,0.05,0.44,0.1,0.6c0.05,0.15,0.12,0.27,0.22,0.34
		s0.22,0.11,0.38,0.11s0.28-0.04,0.38-0.11s0.17-0.18,0.22-0.34c0.05-0.15,0.08-0.35,0.1-0.6c0.02-0.25,0.03-0.54,0.03-0.89
		s-0.01-0.65-0.03-0.89c-0.02-0.24-0.05-0.44-0.1-0.6c-0.05-0.16-0.12-0.27-0.22-0.34s-0.22-0.11-0.38-0.11s-0.28,0.04-0.38,0.11
		s-0.17,0.18-0.22,0.34c-0.05,0.16-0.08,0.35-0.1,0.6c-0.02,0.24-0.03,0.54-0.03,0.89S170.78,205.15,170.8,205.4z"/>
				<path class="st2" d="M176.36,205.47h0.01v-3.56h0.96v5.2h-1.2l-1.28-3.64h-0.01v3.64h-0.96v-5.2h1.21L176.36,205.47z" />
				<path class="st2" d="M180.38,201.9l1.38,5.2h-1.09l-0.24-1.1h-1.38l-0.24,1.1h-1.09l1.38-5.2H180.38z M180.24,205.15l-0.5-2.34
		h-0.01l-0.5,2.34H180.24z"/>
				<path class="st2" d="M183.7,201.9l0.74,3.67h0.01l0.75-3.67h1.55v5.2h-0.96v-4.15h-0.01l-0.93,4.15h-0.82l-0.93-4.15h-0.01v4.15
		h-0.96v-5.2H183.7z"/>
				<path class="st2" d="M187.56,201.9h1.05v5.2h-1.05V201.9z" />
				<path class="st2" d="M192.3,202.76h-1.86v1.22h1.75v0.86h-1.75v1.4h1.93v0.86h-2.98v-5.2h2.91V202.76z" />
				<path class="st2" d="M195.37,205.47h0.01v-3.56h0.96v5.2h-1.2l-1.28-3.64h-0.01v3.64h-0.96v-5.2h1.21L195.37,205.47z" />
				<path class="st2" d="M200.12,202.76h-1.14v4.34h-1.05v-4.34h-1.14v-0.86h3.32V202.76z" />
				<path class="st2" d="M200.52,203.42c0.04-0.33,0.12-0.62,0.24-0.86c0.12-0.24,0.3-0.42,0.54-0.56c0.23-0.13,0.55-0.2,0.94-0.2
		s0.71,0.07,0.94,0.2c0.23,0.13,0.41,0.32,0.54,0.56c0.12,0.24,0.2,0.52,0.24,0.86c0.04,0.33,0.05,0.7,0.05,1.09
		c0,0.4-0.02,0.76-0.05,1.09c-0.04,0.33-0.12,0.61-0.24,0.85c-0.12,0.24-0.3,0.42-0.54,0.55c-0.23,0.13-0.55,0.19-0.94,0.19
		s-0.71-0.06-0.94-0.19c-0.23-0.13-0.41-0.31-0.54-0.55c-0.12-0.24-0.2-0.52-0.24-0.85c-0.04-0.33-0.05-0.69-0.05-1.09
		C200.47,204.11,200.48,203.75,200.52,203.42z M201.54,205.4c0.02,0.25,0.05,0.44,0.1,0.6c0.05,0.15,0.12,0.27,0.22,0.34
		s0.22,0.11,0.38,0.11s0.28-0.04,0.38-0.11s0.17-0.18,0.22-0.34c0.05-0.15,0.08-0.35,0.1-0.6c0.02-0.25,0.03-0.54,0.03-0.89
		s-0.01-0.65-0.03-0.89c-0.02-0.24-0.05-0.44-0.1-0.6c-0.05-0.16-0.12-0.27-0.22-0.34s-0.22-0.11-0.38-0.11s-0.28,0.04-0.38,0.11
		s-0.17,0.18-0.22,0.34c-0.05,0.16-0.08,0.35-0.1,0.6c-0.02,0.24-0.03,0.54-0.03,0.89S201.52,205.15,201.54,205.4z"/>
				<path class="st2" d="M209.28,202.76h-1.86v1.22h1.75v0.86h-1.75v1.4h1.93v0.86h-2.98v-5.2h2.91V202.76z" />
				<path class="st2" d="M212.36,205.47h0.01v-3.56h0.96v5.2h-1.2l-1.28-3.64h-0.01v3.64h-0.96v-5.2h1.21L212.36,205.47z" />
				<path class="st2" d="M217.9,202.83c-0.09-0.17-0.25-0.26-0.49-0.26c-0.13,0-0.24,0.04-0.32,0.11s-0.15,0.18-0.2,0.34
		c-0.05,0.16-0.08,0.36-0.1,0.62c-0.02,0.25-0.03,0.57-0.03,0.94c0,0.39,0.01,0.71,0.04,0.95c0.03,0.24,0.07,0.43,0.12,0.56
		c0.06,0.13,0.13,0.22,0.21,0.27c0.08,0.05,0.18,0.07,0.29,0.07c0.09,0,0.18-0.02,0.26-0.05c0.08-0.03,0.15-0.09,0.21-0.19
		c0.06-0.09,0.1-0.23,0.14-0.4c0.03-0.17,0.05-0.4,0.05-0.68h1.05c0,0.28-0.02,0.55-0.07,0.8c-0.04,0.25-0.12,0.47-0.24,0.66
		s-0.29,0.34-0.5,0.44s-0.5,0.16-0.84,0.16c-0.39,0-0.71-0.06-0.94-0.19c-0.23-0.13-0.41-0.31-0.54-0.55
		c-0.12-0.24-0.2-0.52-0.24-0.85c-0.04-0.33-0.05-0.69-0.05-1.09c0-0.39,0.02-0.76,0.05-1.09s0.12-0.62,0.24-0.86
		c0.12-0.24,0.3-0.42,0.54-0.56c0.23-0.13,0.55-0.2,0.94-0.2c0.37,0,0.67,0.06,0.89,0.18c0.22,0.12,0.38,0.28,0.48,0.46
		c0.11,0.19,0.17,0.39,0.2,0.6s0.04,0.42,0.04,0.61h-1.05C218.03,203.28,217.99,203,217.9,202.83z"/>
				<path class="st2" d="M222.03,201.9l1.38,5.2h-1.09l-0.24-1.1h-1.38l-0.24,1.1h-1.09l1.38-5.2H222.03z M221.89,205.15l-0.5-2.34
		h-0.01l-0.5,2.34H221.89z"/>
				<path class="st2" d="M223.77,201.9h1.05v4.34h1.86v0.86h-2.91V201.9z" />
				<path class="st2" d="M227.15,201.9h1.05v4.34h1.86v0.86h-2.91V201.9z" />
				<path class="st2" d="M233.43,202.76h-1.86v1.22h1.75v0.86h-1.75v1.4h1.93v0.86h-2.98v-5.2h2.91V202.76z" />
			</g>
			<g>
				<path class="st2" d="M161.3,175.84h-1.86v1.22h1.75v0.86h-1.75v1.4h1.93v0.86h-2.98v-5.2h2.91V175.84z" />
				<path class="st2" d="M162.75,178.71c0,0.12,0.01,0.23,0.03,0.33s0.06,0.18,0.11,0.25c0.05,0.07,0.12,0.12,0.21,0.16
		s0.2,0.06,0.34,0.06c0.16,0,0.3-0.05,0.43-0.16c0.13-0.1,0.19-0.27,0.19-0.48c0-0.12-0.02-0.22-0.05-0.3s-0.08-0.16-0.16-0.23
		c-0.07-0.07-0.17-0.13-0.29-0.19c-0.12-0.06-0.27-0.11-0.44-0.17c-0.23-0.08-0.44-0.16-0.61-0.26s-0.31-0.2-0.43-0.32
		c-0.12-0.12-0.2-0.27-0.25-0.43c-0.05-0.16-0.08-0.35-0.08-0.56c0-0.51,0.14-0.9,0.43-1.15s0.68-0.38,1.18-0.38
		c0.23,0,0.45,0.03,0.64,0.08c0.2,0.05,0.37,0.13,0.51,0.25c0.14,0.11,0.25,0.26,0.33,0.44c0.08,0.18,0.12,0.39,0.12,0.64v0.15
		h-1.01c0-0.25-0.04-0.44-0.13-0.57s-0.23-0.2-0.44-0.2c-0.12,0-0.21,0.02-0.29,0.05s-0.14,0.08-0.19,0.13
		c-0.05,0.06-0.08,0.12-0.1,0.19c-0.02,0.07-0.03,0.15-0.03,0.23c0,0.16,0.04,0.29,0.1,0.4c0.07,0.11,0.21,0.21,0.44,0.3l0.81,0.35
		c0.2,0.09,0.36,0.18,0.49,0.27c0.13,0.09,0.23,0.2,0.3,0.31c0.08,0.11,0.13,0.23,0.16,0.36c0.03,0.13,0.04,0.28,0.04,0.44
		c0,0.55-0.16,0.95-0.48,1.2c-0.32,0.25-0.76,0.38-1.33,0.38c-0.59,0-1.02-0.13-1.27-0.39c-0.26-0.26-0.38-0.63-0.38-1.11v-0.21
		h1.05V178.71z"/>
				<path class="st2" d="M168.73,175.84h-1.14v4.34h-1.05v-4.34h-1.13v-0.86h3.32V175.84z" />
				<path class="st2" d="M171.09,174.98l1.38,5.2h-1.09l-0.24-1.1h-1.38l-0.24,1.1h-1.09l1.38-5.2H171.09z M170.95,178.22l-0.5-2.34
		h-0.01l-0.5,2.34H170.95z"/>
				<path class="st2" d="M174.92,175.91c-0.09-0.17-0.25-0.26-0.49-0.26c-0.13,0-0.24,0.04-0.32,0.11c-0.09,0.07-0.15,0.18-0.2,0.34
		c-0.05,0.16-0.08,0.36-0.1,0.62c-0.02,0.25-0.03,0.57-0.03,0.94c0,0.39,0.01,0.71,0.04,0.95c0.03,0.24,0.07,0.43,0.12,0.56
		c0.06,0.13,0.13,0.22,0.21,0.27c0.09,0.05,0.18,0.07,0.29,0.07c0.09,0,0.18-0.02,0.26-0.05c0.08-0.03,0.15-0.09,0.21-0.19
		s0.1-0.23,0.14-0.4c0.03-0.17,0.05-0.4,0.05-0.68h1.05c0,0.28-0.02,0.55-0.06,0.8c-0.04,0.25-0.12,0.47-0.24,0.66
		s-0.29,0.34-0.5,0.44c-0.21,0.11-0.5,0.16-0.84,0.16c-0.39,0-0.71-0.06-0.94-0.19c-0.23-0.13-0.41-0.31-0.54-0.55
		c-0.12-0.24-0.21-0.52-0.24-0.85c-0.04-0.33-0.05-0.69-0.05-1.09c0-0.39,0.02-0.76,0.05-1.09c0.04-0.33,0.12-0.62,0.24-0.86
		c0.12-0.24,0.3-0.42,0.54-0.56c0.23-0.13,0.55-0.2,0.94-0.2c0.38,0,0.67,0.06,0.89,0.18c0.21,0.12,0.38,0.28,0.48,0.46
		c0.11,0.19,0.17,0.39,0.2,0.6c0.03,0.22,0.04,0.42,0.04,0.61h-1.05C175.05,176.36,175.01,176.08,174.92,175.91z"/>
				<path class="st2" d="M177.73,180.18h-0.96v-1.14h0.96V180.18z" />
			</g>
			<g>
				<path class="st2" d="M206.33,175.84h-1.86v1.22h1.75v0.86h-1.75v1.4h1.93v0.86h-2.98v-5.2h2.91V175.84z" />
				<path class="st2" d="M209.41,178.54h0.01v-3.56h0.96v5.2h-1.2l-1.28-3.64h-0.01v3.64h-0.96v-5.2h1.21L209.41,178.54z" />
				<path class="st2" d="M214.95,175.91c-0.09-0.17-0.25-0.26-0.49-0.26c-0.13,0-0.24,0.04-0.32,0.11s-0.15,0.18-0.2,0.34
		c-0.05,0.16-0.08,0.36-0.1,0.62c-0.02,0.25-0.03,0.57-0.03,0.94c0,0.39,0.01,0.71,0.04,0.95c0.03,0.24,0.07,0.43,0.12,0.56
		c0.06,0.13,0.13,0.22,0.21,0.27c0.08,0.05,0.18,0.07,0.29,0.07c0.09,0,0.18-0.02,0.26-0.05c0.08-0.03,0.15-0.09,0.21-0.19
		c0.06-0.09,0.1-0.23,0.14-0.4c0.03-0.17,0.05-0.4,0.05-0.68h1.05c0,0.28-0.02,0.55-0.07,0.8c-0.04,0.25-0.12,0.47-0.24,0.66
		s-0.29,0.34-0.5,0.44s-0.5,0.16-0.84,0.16c-0.39,0-0.71-0.06-0.94-0.19c-0.23-0.13-0.41-0.31-0.54-0.55
		c-0.12-0.24-0.2-0.52-0.24-0.85c-0.04-0.33-0.05-0.69-0.05-1.09c0-0.39,0.02-0.76,0.05-1.09s0.12-0.62,0.24-0.86
		c0.12-0.24,0.3-0.42,0.54-0.56c0.23-0.13,0.55-0.2,0.94-0.2c0.37,0,0.67,0.06,0.89,0.18c0.22,0.12,0.38,0.28,0.48,0.46
		c0.11,0.19,0.17,0.39,0.2,0.6s0.04,0.42,0.04,0.61h-1.05C215.09,176.36,215.04,176.08,214.95,175.91z"/>
				<path class="st2" d="M219.08,174.98l1.38,5.2h-1.09l-0.24-1.1h-1.38l-0.24,1.1h-1.09l1.38-5.2H219.08z M218.95,178.22l-0.5-2.34
		h-0.01l-0.5,2.34H218.95z"/>
				<path class="st2" d="M220.83,174.98h1.05v4.34h1.86v0.86h-2.91V174.98z" />
				<path class="st2" d="M224.2,174.98h1.05v4.34h1.86v0.86h-2.91V174.98z" />
				<path class="st2" d="M230.48,175.84h-1.86v1.22h1.75v0.86h-1.75v1.4h1.93v0.86h-2.98v-5.2h2.91V175.84z" />
			</g>
			<rect x="135.77" y="183.57" class="st3" width="111.24" height="15.08" />
			<rect x="135.77" y="190.84" class="st2" width="25.27" height="0.54" />
			<rect x="219.21" y="190.84" class="st2" width="27.79" height="0.54" />
			<g>
				<g>
					<path class="st9" d="M129.64,153.14c-0.55,0-1-0.45-1-1v-10.69c0-0.55,0.45-1,1-1s1,0.45,1,1v10.69
			C130.64,152.69,130.19,153.14,129.64,153.14z"/>
					<g>
						<polygon class="st9" points="132.43,151.76 126.84,151.76 129.64,154.56 			" />
					</g>
				</g>
				<g>
					<path class="st9" d="M253.22,349.7c-0.55,0-1-0.45-1-1v-10.69c0-0.55,0.45-1,1-1s1,0.45,1,1v10.69
			C254.22,349.25,253.78,349.7,253.22,349.7z"/>
					<g>
						<polygon class="st9" points="250.43,338.39 256.02,338.39 253.22,335.59 			" />
					</g>
				</g>
				<g>
					<path class="st9" d="M129.64,198.67c-0.55,0-1-0.45-1-1v-10.69c0-0.55,0.45-1,1-1s1,0.45,1,1v10.69
			C130.64,198.22,130.19,198.67,129.64,198.67z"/>
					<g>
						<polygon class="st9" points="132.43,197.3 126.84,197.3 129.64,200.09 			" />
					</g>
				</g>
				<g>
					<path class="st9" d="M253.22,304.17c-0.55,0-1-0.45-1-1v-10.69c0-0.55,0.45-1,1-1s1,0.45,1,1v10.69
			C254.22,303.72,253.78,304.17,253.22,304.17z"/>
					<g>
						<polygon class="st9" points="250.43,292.85 256.02,292.85 253.22,290.06 			" />
					</g>
				</g>
				<g>
					<path class="st9" d="M129.64,301.75c-0.55,0-1-0.45-1-1v-10.69c0-0.55,0.45-1,1-1s1,0.45,1,1v10.69
			C130.64,301.3,130.19,301.75,129.64,301.75z"/>
					<g>
						<polygon class="st9" points="132.43,300.37 126.84,300.37 129.64,303.17 			" />
					</g>
				</g>
				<g>
					<path class="st9" d="M253.22,201.09c-0.55,0-1-0.45-1-1V189.4c0-0.55,0.45-1,1-1s1,0.45,1,1v10.69
			C254.22,200.64,253.78,201.09,253.22,201.09z"/>
					<g>
						<polygon class="st9" points="250.43,189.78 256.02,189.78 253.22,186.98 			" />
					</g>
				</g>
				<g>
					<path class="st9" d="M239.35,186.9c0,0.55-0.45,1-1,1h-10.69c-0.55,0-1-0.45-1-1s0.45-1,1-1h10.69
			C238.9,185.9,239.35,186.35,239.35,186.9z"/>
					<g>
						<polygon class="st9" points="228.04,189.7 228.04,184.11 225.24,186.9 			" />
					</g>
				</g>
				<g>
					<path class="st9" d="M156.91,186.9c0,0.55-0.45,1-1,1h-10.69c-0.55,0-1-0.45-1-1s0.45-1,1-1h10.69
			C156.46,185.9,156.91,186.35,156.91,186.9z"/>
					<g>
						<polygon class="st9" points="145.59,189.7 145.59,184.11 142.8,186.9 			" />
					</g>
				</g>
				<g>
					<path class="st9" d="M142.8,195.13c0-0.55,0.45-1,1-1h10.69c0.55,0,1,0.45,1,1s-0.45,1-1,1H143.8
			C143.25,196.13,142.8,195.69,142.8,195.13z"/>
					<g>
						<polygon class="st9" points="154.11,192.34 154.11,197.93 156.91,195.13 			" />
					</g>
				</g>
				<g>
					<path class="st9" d="M225.24,195.13c0-0.55,0.45-1,1-1h10.69c0.55,0,1,0.45,1,1s-0.45,1-1,1h-10.69
			C225.69,196.13,225.24,195.69,225.24,195.13z"/>
					<g>
						<polygon class="st9" points="236.56,192.34 236.56,197.93 239.35,195.13 			" />
					</g>
				</g>
				<g>
					<path class="st9" d="M129.64,347.28c-0.55,0-1-0.45-1-1v-10.69c0-0.55,0.45-1,1-1s1,0.45,1,1v10.69
			C130.64,346.84,130.19,347.28,129.64,347.28z"/>
					<g>
						<polygon class="st9" points="132.43,345.91 126.84,345.91 129.64,348.7 			" />
					</g>
				</g>
				<g>
					<path class="st9" d="M253.22,155.56c-0.55,0-1-0.45-1-1v-10.69c0-0.55,0.45-1,1-1s1,0.45,1,1v10.69
			C254.22,155.11,253.78,155.56,253.22,155.56z"/>
					<g>
						<polygon class="st9" points="250.43,144.24 256.02,144.24 253.22,141.45 			" />
					</g>
				</g>
				<g>
					<path class="st9" d="M134.2,207.11v0.78h-5.41v2.59h-0.66v-3.38H134.2z" />
					<path class="st9" d="M128.14,213.75l0.55-0.06v-0.03c-0.34-0.24-0.65-0.71-0.65-1.33c0-0.88,0.62-1.33,1.25-1.33
			c1.05,0,1.63,0.94,1.62,2.62H131c0.36,0,1.01-0.1,1.01-0.99c0-0.41-0.13-0.83-0.32-1.13l0.52-0.18c0.23,0.36,0.39,0.88,0.39,1.43
			c0,1.33-0.91,1.66-1.78,1.66h-1.63c-0.38,0-0.75,0.02-1.04,0.07V213.75z M130.36,213.63c0.02-0.86-0.13-1.85-0.98-1.85
			c-0.51,0-0.76,0.34-0.76,0.75c0,0.57,0.36,0.93,0.73,1.05c0.08,0.03,0.17,0.04,0.25,0.04H130.36z"/>
					<path class="st9" d="M128.95,215.56c-0.15,0.23-0.32,0.65-0.32,1.04c0,0.58,0.29,0.85,0.65,0.85c0.38,0,0.58-0.22,0.8-0.81
			c0.28-0.78,0.71-1.15,1.23-1.15c0.7,0,1.28,0.57,1.28,1.5c0,0.44-0.13,0.83-0.27,1.07l-0.58-0.2c0.11-0.17,0.25-0.49,0.25-0.89
			c0-0.47-0.27-0.73-0.59-0.73c-0.36,0-0.52,0.26-0.74,0.83c-0.29,0.76-0.67,1.14-1.31,1.14c-0.77,0-1.31-0.59-1.31-1.63
			c0-0.48,0.12-0.92,0.3-1.22L128.95,215.56z"/>
					<path class="st9" d="M128.33,225.41c-0.14-0.29-0.29-0.86-0.29-1.6c0-1.71,1.08-3,3.07-3c1.9,0,3.19,1.29,3.19,3.17
			c0,0.76-0.16,1.23-0.27,1.44l-0.64-0.19c0.14-0.3,0.25-0.72,0.25-1.22c0-1.42-0.91-2.37-2.5-2.37c-1.49,0-2.44,0.86-2.44,2.33
			c0,0.48,0.1,0.96,0.25,1.28L128.33,225.41z"/>
					<path class="st9" d="M128.14,228.71l0.55-0.06v-0.03c-0.34-0.24-0.65-0.71-0.65-1.33c0-0.88,0.62-1.33,1.25-1.33
			c1.05,0,1.63,0.94,1.62,2.62H131c0.36,0,1.01-0.1,1.01-0.99c0-0.41-0.13-0.83-0.32-1.13l0.52-0.18c0.23,0.36,0.39,0.88,0.39,1.43
			c0,1.33-0.91,1.66-1.78,1.66h-1.63c-0.38,0-0.75,0.02-1.04,0.07V228.71z M130.36,228.6c0.02-0.86-0.13-1.85-0.98-1.85
			c-0.51,0-0.76,0.34-0.76,0.75c0,0.57,0.36,0.93,0.73,1.05c0.08,0.03,0.17,0.04,0.25,0.04H130.36z"/>
					<path class="st9" d="M134.53,230.64v0.79h-6.39v-0.79H134.53z" />
					<path class="st9" d="M128.14,232.76h4.36v0.79h-4.36V232.76z M133.72,233.65c-0.27,0.01-0.49-0.19-0.49-0.5
			c0-0.28,0.22-0.48,0.49-0.48c0.28,0,0.5,0.21,0.5,0.5C134.21,233.46,134,233.65,133.72,233.65z"/>
					<path class="st9" d="M128.14,234.95h3.75v-0.61h0.6v0.61h0.21c0.61,0,1.17,0.13,1.52,0.5c0.29,0.3,0.41,0.69,0.41,1.06
			c0,0.28-0.06,0.52-0.13,0.67l-0.61-0.11c0.05-0.12,0.1-0.28,0.1-0.5c0-0.68-0.59-0.85-1.26-0.85h-0.23v1.05h-0.6v-1.05h-3.75
			V234.95z"/>
					<path class="st9" d="M130.35,241.32c-1.61,0-2.31-1.12-2.31-2.17c0-1.18,0.86-2.09,2.24-2.09c1.46,0,2.31,0.95,2.31,2.16
			C132.59,240.48,131.68,241.32,130.35,241.32z M130.31,237.87c-0.95,0-1.67,0.55-1.67,1.32c0,0.76,0.71,1.32,1.69,1.32
			c0.74,0,1.67-0.37,1.67-1.31C132,238.27,131.13,237.87,130.31,237.87z"/>
					<path class="st9" d="M131.13,242.32c0.51,0,0.95-0.01,1.36-0.04v0.69l-0.86,0.03v0.04c0.58,0.2,0.95,0.68,0.95,1.21
			c0,0.09-0.01,0.15-0.03,0.22h-0.75c0.02-0.08,0.03-0.16,0.03-0.27c0-0.56-0.42-0.96-1.02-1.06c-0.11-0.02-0.23-0.04-0.37-0.04
			h-2.32v-0.78H131.13z"/>
					<path class="st9" d="M131.31,245.3c0.45,0,0.82-0.01,1.18-0.04v0.7l-0.72,0.04v0.02c0.41,0.22,0.82,0.72,0.82,1.44
			c0,0.6-0.36,1.54-1.85,1.54h-2.6v-0.79h2.51c0.7,0,1.29-0.26,1.29-1.01c0-0.52-0.37-0.93-0.81-1.06c-0.1-0.04-0.23-0.05-0.37-0.05
			h-2.62v-0.79H131.31z"/>
					<path class="st9" d="M128.14,250.29h4.36v0.79h-4.36V250.29z M133.72,251.18c-0.27,0.01-0.49-0.19-0.49-0.5
			c0-0.28,0.22-0.48,0.49-0.48c0.28,0,0.5,0.21,0.5,0.5C134.21,250.99,134,251.18,133.72,251.18z"/>
					<path class="st9" d="M128.14,254.81l0.55-0.06v-0.03c-0.34-0.24-0.65-0.71-0.65-1.33c0-0.88,0.62-1.33,1.25-1.33
			c1.05,0,1.63,0.94,1.62,2.62H131c0.36,0,1.01-0.1,1.01-0.99c0-0.41-0.13-0.83-0.32-1.13l0.52-0.18c0.23,0.36,0.39,0.88,0.39,1.43
			c0,1.33-0.91,1.66-1.78,1.66h-1.63c-0.38,0-0.75,0.02-1.04,0.07V254.81z M130.36,254.7c0.02-0.86-0.13-1.85-0.98-1.85
			c-0.51,0-0.76,0.34-0.76,0.75c0,0.57,0.36,0.93,0.73,1.05c0.08,0.03,0.17,0.04,0.25,0.04H130.36z"/>
					<path class="st9" d="M128.95,256.63c-0.15,0.23-0.32,0.65-0.32,1.04c0,0.58,0.29,0.85,0.65,0.85c0.38,0,0.58-0.22,0.8-0.81
			c0.28-0.78,0.71-1.15,1.23-1.15c0.7,0,1.28,0.57,1.28,1.5c0,0.44-0.13,0.83-0.27,1.07l-0.58-0.2c0.11-0.17,0.25-0.49,0.25-0.89
			c0-0.47-0.27-0.73-0.59-0.73c-0.36,0-0.52,0.26-0.74,0.83c-0.29,0.76-0.67,1.14-1.31,1.14c-0.77,0-1.31-0.59-1.31-1.63
			c0-0.48,0.12-0.92,0.3-1.22L128.95,256.63z"/>
					<path class="st9" d="M134.12,262.24c0.07,0.48,0.13,1.04,0.13,1.67c0,1.12-0.26,1.93-0.76,2.46c-0.5,0.54-1.2,0.86-2.18,0.86
			c-0.99,0-1.8-0.31-2.36-0.87c-0.57-0.57-0.87-1.5-0.87-2.68c0-0.56,0.03-1.03,0.07-1.42H134.12z M128.76,263.02
			c-0.04,0.2-0.04,0.49-0.04,0.79c0,1.67,0.94,2.58,2.58,2.58c1.43,0.01,2.34-0.8,2.34-2.46c0-0.41-0.04-0.71-0.08-0.92H128.76z"/>
					<path class="st9" d="M131.13,268.21c0.51,0,0.95-0.01,1.36-0.04v0.69l-0.86,0.03v0.04c0.58,0.2,0.95,0.68,0.95,1.21
			c0,0.09-0.01,0.15-0.03,0.22h-0.75c0.02-0.08,0.03-0.16,0.03-0.27c0-0.56-0.42-0.95-1.02-1.06c-0.11-0.02-0.23-0.04-0.37-0.04
			h-2.32v-0.78H131.13z"/>
					<path class="st9" d="M128.14,271.18h4.36v0.79h-4.36V271.18z M133.72,272.07c-0.27,0.01-0.49-0.19-0.49-0.5
			c0-0.28,0.22-0.48,0.49-0.48c0.28,0,0.5,0.21,0.5,0.5C134.21,271.88,134,272.07,133.72,272.07z"/>
					<path class="st9" d="M132.49,273.6l-2.45,0.86c-0.4,0.14-0.76,0.26-1.12,0.35v0.03c0.36,0.1,0.72,0.23,1.12,0.37l2.45,0.85v0.83
			l-4.36-1.71v-0.76l4.36-1.66V273.6z"/>
					<path class="st9" d="M130.17,277.97c-1.07,0.02-1.51,0.7-1.51,1.49c0,0.57,0.1,0.91,0.22,1.21l-0.57,0.14
			c-0.13-0.28-0.27-0.76-0.27-1.45c0-1.34,0.88-2.14,2.2-2.14s2.35,0.77,2.35,2.04c0,1.42-1.25,1.8-2.05,1.8
			c-0.16,0-0.29-0.02-0.37-0.03V277.97z M130.74,280.29c0.5,0.01,1.29-0.21,1.29-1.1c0-0.8-0.74-1.15-1.29-1.21V280.29z"/>
				</g>
				<g>
					<path class="st9" d="M252.58,219.01c-2.09,0-3.2-1.27-3.2-2.82c0-1.6,1.24-2.73,3.08-2.73c1.93,0,3.19,1.2,3.19,2.82
			C255.65,217.94,254.38,219.01,252.58,219.01z M252.48,214.3c-1.3,0-2.46,0.7-2.46,1.94c0,1.24,1.14,1.94,2.52,1.94
			c1.21,0,2.47-0.63,2.47-1.94C255.01,214.95,253.81,214.3,252.48,214.3z"/>
					<path class="st9" d="M255.09,221.1h-1.25v1.13h-0.6v-1.13h-2.35c-0.54,0-0.85,0.15-0.85,0.59c0,0.21,0.03,0.36,0.05,0.46
			l-0.59,0.04c-0.06-0.15-0.11-0.4-0.11-0.7c0-0.37,0.12-0.67,0.33-0.86c0.23-0.23,0.62-0.31,1.13-0.31h2.38v-0.67h0.6v0.67h1.04
			L255.09,221.1z"/>
					<path class="st9" d="M249.48,225.54l0.55-0.06v-0.03c-0.34-0.24-0.65-0.71-0.65-1.33c0-0.88,0.62-1.33,1.25-1.33
			c1.05,0,1.63,0.94,1.62,2.62h0.09c0.36,0,1.01-0.1,1.01-0.99c0-0.41-0.13-0.83-0.32-1.13l0.52-0.18c0.23,0.36,0.39,0.88,0.39,1.43
			c0,1.33-0.91,1.66-1.78,1.66h-1.63c-0.38,0-0.75,0.02-1.04,0.07V225.54z M251.71,225.42c0.02-0.86-0.13-1.85-0.98-1.85
			c-0.51,0-0.76,0.34-0.76,0.75c0,0.57,0.36,0.93,0.73,1.05c0.08,0.03,0.17,0.04,0.25,0.04H251.71z"/>
					<path class="st9" d="M253.84,227.68l-2.58,0.95c-0.29,0.1-0.63,0.21-0.89,0.28v0.02c0.26,0.08,0.59,0.17,0.91,0.28l2.56,0.86v0.84
			l-3.11-1.19c-1.49-0.57-2.26-0.96-2.73-1.5c-0.34-0.39-0.48-0.77-0.51-0.97l0.67-0.2c0.06,0.2,0.19,0.46,0.39,0.69
			c0.17,0.22,0.48,0.49,0.88,0.67c0.08,0.04,0.14,0.06,0.19,0.06s0.11-0.02,0.21-0.05l4.02-1.61V227.68z"/>
					<path class="st9" d="M255.48,233.57c0.06,0.38,0.12,0.87,0.12,1.5c0,0.77-0.18,1.34-0.5,1.7c-0.29,0.33-0.73,0.53-1.27,0.53
			c-0.55,0-0.98-0.16-1.3-0.47c-0.44-0.41-0.67-1.09-0.67-1.85c0-0.23,0.01-0.45,0.05-0.63h-2.43v-0.78H255.48z M252.56,234.35
			c-0.04,0.17-0.06,0.39-0.06,0.65c0,0.95,0.46,1.52,1.3,1.52c0.8,0,1.19-0.57,1.19-1.43c0-0.34-0.03-0.6-0.06-0.74H252.56z"/>
					<path class="st9" d="M249.48,240.51l0.55-0.06v-0.03c-0.34-0.24-0.65-0.71-0.65-1.33c0-0.88,0.62-1.33,1.25-1.33
			c1.05,0,1.63,0.94,1.62,2.62h0.09c0.36,0,1.01-0.1,1.01-0.99c0-0.41-0.13-0.83-0.32-1.13l0.52-0.18c0.23,0.36,0.39,0.88,0.39,1.43
			c0,1.33-0.91,1.66-1.78,1.66h-1.63c-0.38,0-0.75,0.02-1.04,0.07V240.51z M251.71,240.39c0.02-0.86-0.13-1.85-0.98-1.85
			c-0.51,0-0.76,0.34-0.76,0.75c0,0.57,0.36,0.93,0.73,1.05c0.08,0.03,0.17,0.04,0.25,0.04H251.71z"/>
					<path class="st9" d="M249.65,245.54c-0.11-0.21-0.25-0.67-0.25-1.25c0-1.31,0.89-2.17,2.22-2.17c1.34,0,2.31,0.92,2.31,2.34
			c0,0.47-0.12,0.88-0.22,1.1l-0.61-0.18c0.11-0.19,0.21-0.49,0.21-0.92c0-1-0.74-1.54-1.65-1.54c-1.01,0-1.63,0.65-1.63,1.51
			c0,0.45,0.12,0.75,0.22,0.97L249.65,245.54z"/>
					<path class="st9" d="M249.48,246.46h4.36v0.79h-4.36V246.46z M255.07,247.35c-0.27,0.01-0.49-0.19-0.49-0.5
			c0-0.28,0.22-0.48,0.49-0.48c0.28,0,0.5,0.21,0.5,0.5C255.56,247.16,255.35,247.35,255.07,247.35z"/>
					<path class="st9" d="M249.48,248.65h3.75v-0.61h0.6v0.61h0.23c1.15,0,1.9,0.67,1.9,1.9c0,0.41-0.13,0.88-0.29,1.11l-0.6-0.22
			c0.13-0.19,0.25-0.53,0.25-0.92c0-0.84-0.58-1.08-1.28-1.08h-0.22v2.53h-4.36v-0.78h3.75v-1.75h-3.75V248.65z"/>
					<path class="st9" d="M249.65,256.38c-0.11-0.21-0.25-0.67-0.25-1.25c0-1.31,0.89-2.17,2.22-2.17c1.34,0,2.31,0.92,2.31,2.34
			c0,0.47-0.12,0.88-0.22,1.1l-0.61-0.18c0.11-0.19,0.21-0.49,0.21-0.92c0-1-0.74-1.54-1.65-1.54c-1.01,0-1.63,0.65-1.63,1.51
			c0,0.45,0.12,0.75,0.22,0.97L249.65,256.38z"/>
					<path class="st9" d="M255.47,259.25c0.07,0.48,0.13,1.04,0.13,1.67c0,1.12-0.26,1.93-0.76,2.46c-0.5,0.54-1.2,0.86-2.18,0.86
			c-0.99,0-1.8-0.31-2.36-0.87c-0.57-0.57-0.87-1.5-0.87-2.68c0-0.56,0.03-1.03,0.07-1.42H255.47z M250.11,260.03
			c-0.04,0.2-0.04,0.49-0.04,0.79c0,1.67,0.94,2.58,2.58,2.58c1.43,0.01,2.34-0.8,2.34-2.46c0-0.41-0.04-0.71-0.08-0.92H250.11z"/>
					<path class="st9" d="M252.48,265.21c0.51,0,0.95-0.01,1.36-0.04v0.69l-0.86,0.03v0.04c0.58,0.2,0.95,0.68,0.95,1.21
			c0,0.09-0.01,0.15-0.03,0.22h-0.75c0.02-0.08,0.03-0.16,0.03-0.27c0-0.56-0.42-0.96-1.02-1.06c-0.11-0.02-0.23-0.04-0.37-0.04
			h-2.32v-0.78H252.48z"/>
					<path class="st9" d="M249.48,268.19h4.36v0.79h-4.36V268.19z M255.07,269.07c-0.27,0.01-0.49-0.19-0.49-0.5
			c0-0.28,0.22-0.48,0.49-0.48c0.28,0,0.5,0.21,0.5,0.5C255.56,268.88,255.35,269.07,255.07,269.07z"/>
					<path class="st9" d="M253.84,270.6l-2.45,0.86c-0.4,0.14-0.76,0.26-1.12,0.35v0.03c0.36,0.1,0.72,0.23,1.12,0.37l2.45,0.85v0.83
			l-4.36-1.71v-0.76l4.36-1.66V270.6z"/>
					<path class="st9" d="M251.52,274.98c-1.07,0.02-1.51,0.7-1.51,1.49c0,0.57,0.1,0.91,0.22,1.21l-0.57,0.14
			c-0.13-0.28-0.27-0.76-0.27-1.45c0-1.34,0.88-2.14,2.2-2.14s2.35,0.77,2.35,2.04c0,1.42-1.25,1.8-2.05,1.8
			c-0.16,0-0.29-0.02-0.37-0.03V274.98z M252.09,277.3c0.5,0.01,1.29-0.21,1.29-1.1c0-0.8-0.74-1.15-1.29-1.21V277.3z"/>
				</g>
				<g>
					<path class="st9" d="M170.21,191.04c0,2.09-1.27,3.2-2.82,3.2c-1.6,0-2.73-1.24-2.73-3.08c0-1.93,1.2-3.19,2.82-3.19
			C169.14,187.97,170.21,189.24,170.21,191.04z M165.5,191.14c0,1.3,0.7,2.46,1.94,2.46c1.24,0,1.94-1.14,1.94-2.52
			c0-1.21-0.63-2.47-1.94-2.47C166.15,188.61,165.5,189.8,165.5,191.14z"/>
					<path class="st9" d="M172.3,188.52v1.25h1.13v0.6h-1.13v2.35c0,0.54,0.15,0.85,0.59,0.85c0.21,0,0.36-0.03,0.46-0.05l0.04,0.59
			c-0.15,0.06-0.4,0.11-0.7,0.11c-0.37,0-0.67-0.12-0.86-0.33c-0.23-0.23-0.31-0.62-0.31-1.13v-2.38h-0.67v-0.6h0.67v-1.04
			L172.3,188.52z"/>
					<path class="st9" d="M176.74,194.13l-0.06-0.55h-0.03c-0.24,0.34-0.71,0.65-1.33,0.65c-0.88,0-1.33-0.62-1.33-1.25
			c0-1.05,0.94-1.63,2.62-1.62v-0.09c0-0.36-0.1-1.01-0.99-1.01c-0.41,0-0.83,0.13-1.13,0.32l-0.18-0.52
			c0.36-0.23,0.88-0.39,1.43-0.39c1.33,0,1.66,0.91,1.66,1.78v1.63c0,0.38,0.02,0.75,0.07,1.04H176.74z M176.62,191.91
			c-0.86-0.02-1.85,0.13-1.85,0.98c0,0.51,0.34,0.76,0.75,0.76c0.57,0,0.93-0.36,1.05-0.73c0.03-0.08,0.04-0.17,0.04-0.25V191.91z"
					/>
					<path class="st9" d="M178.88,189.78l0.95,2.58c0.1,0.29,0.21,0.63,0.28,0.89h0.02c0.08-0.26,0.17-0.59,0.28-0.91l0.86-2.56h0.84
			l-1.19,3.11c-0.57,1.49-0.96,2.26-1.5,2.73c-0.39,0.34-0.77,0.48-0.97,0.51l-0.2-0.67c0.2-0.06,0.46-0.19,0.69-0.39
			c0.22-0.17,0.49-0.48,0.67-0.88c0.04-0.08,0.06-0.14,0.06-0.19s-0.02-0.11-0.05-0.21l-1.61-4.02H178.88z"/>
					<path class="st9" d="M184.77,188.14c0.38-0.06,0.87-0.12,1.5-0.12c0.77,0,1.34,0.18,1.7,0.5c0.33,0.29,0.53,0.73,0.53,1.27
			c0,0.55-0.16,0.98-0.47,1.3c-0.41,0.44-1.09,0.67-1.85,0.67c-0.23,0-0.45-0.01-0.63-0.05v2.43h-0.78V188.14z M185.55,191.06
			c0.17,0.04,0.39,0.06,0.65,0.06c0.95,0,1.52-0.46,1.52-1.3c0-0.8-0.57-1.19-1.43-1.19c-0.34,0-0.6,0.03-0.74,0.06V191.06z"/>
					<path class="st9" d="M191.71,194.13l-0.06-0.55h-0.03c-0.24,0.34-0.71,0.65-1.33,0.65c-0.88,0-1.33-0.62-1.33-1.25
			c0-1.05,0.94-1.63,2.62-1.62v-0.09c0-0.36-0.1-1.01-0.99-1.01c-0.41,0-0.83,0.13-1.13,0.32l-0.18-0.52
			c0.36-0.23,0.88-0.39,1.43-0.39c1.33,0,1.66,0.91,1.66,1.78v1.63c0,0.38,0.02,0.75,0.07,1.04H191.71z M191.59,191.91
			c-0.86-0.02-1.85,0.13-1.85,0.98c0,0.51,0.34,0.76,0.75,0.76c0.57,0,0.93-0.36,1.05-0.73c0.03-0.08,0.04-0.17,0.04-0.25V191.91z"
					/>
					<path class="st9" d="M196.74,193.97c-0.21,0.11-0.67,0.25-1.25,0.25c-1.31,0-2.17-0.89-2.17-2.22c0-1.34,0.92-2.31,2.34-2.31
			c0.47,0,0.88,0.12,1.1,0.22l-0.18,0.61c-0.19-0.11-0.49-0.21-0.92-0.21c-1,0-1.54,0.74-1.54,1.65c0,1.01,0.65,1.63,1.51,1.63
			c0.45,0,0.75-0.12,0.97-0.22L196.74,193.97z"/>
					<path class="st9" d="M198.55,188.55c0.01,0.27-0.19,0.49-0.5,0.49c-0.28,0-0.48-0.22-0.48-0.49c0-0.28,0.21-0.5,0.5-0.5
			C198.36,188.06,198.55,188.27,198.55,188.55z M197.67,194.13v-4.36h0.79v4.36H197.67z"/>
					<path class="st9" d="M199.85,194.13v-3.75h-0.61v-0.6h0.61v-0.23c0-1.15,0.67-1.9,1.9-1.9c0.41,0,0.88,0.13,1.11,0.29l-0.22,0.6
			c-0.19-0.13-0.53-0.25-0.92-0.25c-0.84,0-1.08,0.58-1.08,1.28v0.22h2.53v4.36h-0.78v-3.75h-1.75v3.75H199.85z"/>
					<path class="st9" d="M207.58,193.97c-0.21,0.11-0.67,0.25-1.25,0.25c-1.31,0-2.17-0.89-2.17-2.22c0-1.34,0.92-2.31,2.34-2.31
			c0.47,0,0.88,0.12,1.1,0.22l-0.18,0.61c-0.19-0.11-0.49-0.21-0.92-0.21c-1,0-1.54,0.74-1.54,1.65c0,1.01,0.65,1.63,1.51,1.63
			c0.45,0,0.75-0.12,0.97-0.22L207.58,193.97z"/>
					<path class="st9" d="M210.45,188.14c0.38-0.06,0.87-0.12,1.5-0.12c0.77,0,1.34,0.18,1.7,0.5c0.33,0.29,0.53,0.73,0.53,1.27
			c0,0.55-0.16,0.98-0.47,1.3c-0.41,0.44-1.09,0.67-1.85,0.67c-0.23,0-0.45-0.01-0.63-0.05v2.43h-0.78V188.14z M211.23,191.06
			c0.17,0.04,0.39,0.06,0.65,0.06c0.95,0,1.52-0.46,1.52-1.3c0-0.8-0.57-1.19-1.43-1.19c-0.34,0-0.6,0.03-0.74,0.06V191.06z"/>
					<path class="st9" d="M215.16,187.74h0.79v6.39h-0.79V187.74z" />
				</g>
				<g>
					<path class="st9" d="M149.84,88.57c-0.32,0-0.64-0.15-0.83-0.44c-0.31-0.46-0.19-1.08,0.27-1.39l8.86-5.98
			c0.46-0.31,1.08-0.19,1.39,0.27c0.31,0.46,0.19,1.08-0.27,1.39l-8.86,5.98C150.22,88.52,150.03,88.57,149.84,88.57z"/>
					<g>
						<polygon class="st9" points="151.71,89.68 148.58,85.05 147.83,88.93 			" />
					</g>
				</g>
				<g>
					<path class="st9" d="M253.06,119.5c-0.55,0-1-0.45-1-1v-1.68c0-2.87-0.98-4.39-2.6-6.54c-0.33-0.44-0.24-1.07,0.2-1.4
			c0.44-0.33,1.07-0.24,1.4,0.2c1.48,1.97,3,4,3,7.74v1.68C254.06,119.05,253.61,119.5,253.06,119.5z"/>
					<g>
						<polygon class="st9" points="248.22,111.63 252.74,108.33 248.83,107.72 			" />
					</g>
				</g>
				<g>
					<path class="st9" d="M130.27,119.13c-0.01,0-0.02,0-0.02,0c-0.55-0.01-0.99-0.47-0.98-1.02c0.06-2.46,0.12-5,2.44-7.94
			c0.4-0.51,2.06-2.72,2.06-2.73l1.6,1.2c0,0-1.69,2.25-2.09,2.76c-1.78,2.25-1.95,4.05-2.01,6.75
			C131.26,118.69,130.81,119.13,130.27,119.13z"/>
					<g>
						<polygon class="st9" points="133.08,117.86 127.49,117.65 130.18,120.55 			" />
					</g>
				</g>
			</g>
			<g>
				<g fill={lotIdentifier === 'F' ? "#FFFFFF" : "#606161"} >
					<rect x="228.75" y="226.61" width="7.28" height="2.28" />
					<polygon points="229.2,231.72 216.68,227.75 229.2,223.77 		" />
				</g>
				<g fill={lotIdentifier === 'H' ? "#FFFFFF" : "#606161"} >
					<rect x="113.57" y="225.27" width="6.93" height="2.28" />
					<polygon points="114.02,230.38 101.5,226.41 114.02,222.43 		" />
				</g>
				<g fill={lotIdentifier === 'G' ? "#FFFFFF" : "#606161"} >
					<rect x="113.57" y="322.14" width="6.92" height="2.28" />
					<polygon points="114.02,327.26 101.5,323.28 114.02,319.31 		" />
				</g>
				<g fill={lotIdentifier === 'J' ? "#FFFFFF" : "#606161"}  >

					<rect x="36.6" y="354.59" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 395.7927 315.661)" width="6.92" height="2.28" />
					<polygon points="36.09,352.72 40.07,340.2 44.04,352.72 		" />
				</g>
				<g fill={lotIdentifier === 'A' ? "#FFFFFF" : "#606161"} >

					<rect x="188.82" y="167.95" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 361.59 -23.4163)" width="7.36" height="2.28" />
					<polygon points="188.53,165.86 192.5,153.34 196.48,165.86 		" />
				</g>
				<g fill={lotIdentifier === 'B' ? "#FFFFFF" : "#606161"} >
					<polygon points="122.63,93.41 127.3,97.2 126.11,99.15 121.19,95.18 		" />
					<polygon points="119.76,97.67 112.55,86.69 124.77,91.5 		" />
				</g>
				<g fill={lotIdentifier === 'A' ? "#FFFFFF" : "#606161"} >
					<polygon points="231.82,157.62 236.09,163.57 236.09,167.56 229.96,158.94 		" />
					<polygon points="227.92,160.95 223.9,148.44 234.4,156.35 		" />
				</g>
				<g fill={lotIdentifier === 'E' ? "#FFFFFF" : "#606161"} >
					<rect x="228.75" y="271.12" width="7.27" height="2.28" />
					<polygon points="229.2,276.23 216.68,272.26 229.2,268.29 		" />
				</g>
				<g fill={lotIdentifier === 'E' ? "#FFFFFF" : "#606161"} >
					<rect x="228.75" y="301.39" width="7.27" height="2.28" />
					<polygon points="229.2,306.5 216.68,302.53 229.2,298.55 		" />
				</g>
				<g fill={lotIdentifier === 'C' ? "#FFFFFF" : "#606161"} >

					<rect x="261.45" y="311.23" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 529.8494 624.7363)" width="6.94" height="2.28" />
					<polygon points="267.94,308.4 280.46,312.37 267.94,316.34 		" />
				</g>
				<g fill={lotIdentifier === 'D' ? "#FFFFFF" : "#606161"} >

					<rect x="261.45" y="226.37" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 529.8494 455.0258)" width="6.94" height="2.28" />
					<polygon points="267.94,223.54 280.46,227.51 267.94,231.49 		" />
				</g>
			</g>
			<g>
				<path class="st2" d="M171.9,99.22h0.03l0.92-4.56h1.29l-1.42,6.17h-1.6l-1.42-6.17h1.33L171.9,99.22z" />
				<path class="st2" d="M177.01,94.65l1.63,6.17h-1.3l-0.29-1.3h-1.64l-0.29,1.3h-1.3l1.63-6.17H177.01z M176.84,98.5l-0.6-2.77h-0.02
		l-0.6,2.77H176.84z"/>
				<path class="st2" d="M179.07,94.65h1.25v5.15h2.2v1.02h-3.45V94.65z" />
				<path class="st2" d="M186.52,95.67h-2.2v1.45h2.07v1.02h-2.07v1.66h2.29v1.02h-3.54v-6.17h3.45V95.67z" />
				<path class="st2" d="M190.84,95.67h-1.35v5.15h-1.24v-5.15h-1.35v-1.02h3.94V95.67z" />
				<path class="st2" d="M195.63,94.65c0.32,0,0.58,0.05,0.8,0.16c0.22,0.11,0.39,0.25,0.52,0.42s0.23,0.37,0.29,0.59
		s0.09,0.45,0.09,0.68c0,0.32-0.05,0.59-0.14,0.83c-0.1,0.24-0.23,0.43-0.4,0.58c-0.17,0.15-0.38,0.26-0.62,0.34
		c-0.24,0.08-0.51,0.11-0.8,0.11h-0.67v2.46h-1.25v-6.17H195.63z M195.25,97.45c0.25,0,0.45-0.07,0.6-0.22
		c0.15-0.15,0.23-0.38,0.23-0.7c0-0.31-0.07-0.55-0.2-0.71c-0.13-0.16-0.35-0.24-0.67-0.24h-0.52v1.88H195.25z"/>
				<path class="st2" d="M200.35,94.65l1.63,6.17h-1.3l-0.29-1.3h-1.64l-0.29,1.3h-1.3l1.63-6.17H200.35z M200.19,98.5l-0.6-2.77h-0.02
		l-0.6,2.77H200.19z"/>
				<path class="st2" d="M204.72,94.65c0.52,0,0.92,0.13,1.21,0.39c0.29,0.26,0.43,0.66,0.43,1.2c0,0.42-0.08,0.75-0.25,1.02
		s-0.43,0.43-0.78,0.51v0.02c0.31,0.05,0.54,0.15,0.68,0.3c0.14,0.16,0.23,0.41,0.27,0.75c0.01,0.12,0.02,0.24,0.03,0.38
		c0.01,0.14,0.01,0.29,0.02,0.45c0.01,0.33,0.03,0.58,0.05,0.75c0.03,0.17,0.11,0.29,0.22,0.35v0.05h-1.35
		c-0.06-0.09-0.1-0.19-0.12-0.3c-0.02-0.11-0.03-0.23-0.04-0.35l-0.03-1.18c-0.01-0.24-0.07-0.43-0.18-0.57s-0.29-0.21-0.55-0.21
		h-0.67v2.61h-1.25v-6.17H204.72z M204.18,97.35c0.3,0,0.53-0.07,0.69-0.21c0.16-0.14,0.24-0.38,0.24-0.71
		c0-0.57-0.29-0.86-0.86-0.86h-0.59v1.78H204.18z"/>
				<path class="st2" d="M208.47,97.13h0.02l1.57-2.47h1.35l-1.68,2.64l1.87,3.53h-1.4l-1.27-2.53l-0.46,0.7v1.83h-1.25v-6.17h1.25
		V97.13z"/>
				<path class="st2" d="M211.92,94.65h1.25v6.17h-1.25V94.65z" />
				<path class="st2" d="M217.03,98.88h0.02v-4.23h1.14v6.17h-1.42l-1.52-4.32h-0.02v4.32h-1.14v-6.17h1.43L217.03,98.88z" />
				<path class="st2" d="M221.75,96.13c-0.03-0.12-0.07-0.23-0.13-0.33c-0.06-0.1-0.13-0.18-0.22-0.25c-0.09-0.07-0.2-0.1-0.32-0.1
		c-0.3,0-0.52,0.17-0.65,0.5s-0.2,0.89-0.2,1.66c0,0.37,0.01,0.7,0.03,1c0.02,0.3,0.06,0.55,0.12,0.76s0.15,0.37,0.26,0.48
		s0.26,0.17,0.44,0.17c0.07,0,0.16-0.02,0.25-0.06c0.09-0.04,0.17-0.1,0.25-0.18c0.08-0.08,0.14-0.18,0.2-0.31
		c0.05-0.12,0.08-0.27,0.08-0.44v-0.63h-0.82V97.5h2.01v3.33h-0.92v-0.57h-0.02c-0.15,0.24-0.33,0.41-0.54,0.51
		c-0.21,0.1-0.46,0.15-0.76,0.15c-0.38,0-0.69-0.07-0.93-0.2c-0.24-0.13-0.43-0.34-0.56-0.61s-0.23-0.62-0.27-1.02
		s-0.07-0.88-0.07-1.41c0-0.52,0.03-0.97,0.1-1.37c0.07-0.39,0.18-0.72,0.34-0.98s0.37-0.46,0.64-0.59c0.26-0.13,0.6-0.2,0.99-0.2
		c0.68,0,1.17,0.17,1.47,0.51c0.3,0.34,0.45,0.82,0.45,1.45h-1.19C221.79,96.37,221.78,96.25,221.75,96.13z"/>
			</g>
			<circle class="st11" cx="231" cy="95.64" r="5.75" />
			<circle class="st2" cx="231" cy="95.64" r="2.99" />
			<g>
				<path class="st12" d="M301.17,307.76h-22.61c-4.18,0-7.57-3.39-7.57-7.57v-14.41c0-4.18,3.39-7.57,7.57-7.57h22.61
		c4.18,0,7.57,3.39,7.57,7.57v14.41C308.73,304.37,305.35,307.76,301.17,307.76z"/>
				<g>
					<g>
						<path class="st2" d="M277.76,286.6h-0.74v1.33h-0.97v-4.42h1.81c1.06,0,1.69,0.63,1.69,1.53v0.01
				C279.55,286.07,278.75,286.6,277.76,286.6z M278.56,285.05c0-0.44-0.3-0.67-0.79-0.67h-0.75v1.35h0.77
				c0.49,0,0.77-0.29,0.77-0.67V285.05z"/>
						<path class="st2" d="M282.52,287.93l-0.95-1.42h-0.76v1.42h-0.97v-4.42h2.02c1.04,0,1.67,0.55,1.67,1.46v0.01
				c0,0.71-0.38,1.16-0.95,1.37l1.08,1.58H282.52z M282.53,285.02c0-0.42-0.29-0.63-0.76-0.63h-0.97v1.27h0.99
				c0.47,0,0.75-0.25,0.75-0.62V285.02z"/>
						<path class="st2" d="M283.99,287.93v-4.42h3.34v0.87h-2.37v0.9h2.08v0.87h-2.08v0.93h2.4v0.87H283.99z" />
						<path class="st2" d="M291.3,287.93v-2.89l-1.25,1.89h-0.02l-1.23-1.87v2.87h-0.95v-4.42h1.05l1.16,1.87l1.16-1.87h1.05v4.42
				H291.3z"/>
						<path class="st2" d="M292.95,287.93v-4.42h0.97v4.42H292.95z" />
						<path class="st2" d="M296.46,288c-1.19,0-1.91-0.66-1.91-1.96v-2.53h0.97v2.5c0,0.72,0.36,1.09,0.95,1.09s0.95-0.36,0.95-1.06
				v-2.53h0.97v2.5C298.4,287.34,297.65,288,296.46,288z"/>
						<path class="st2" d="M302.47,287.93v-2.89l-1.25,1.89h-0.02l-1.23-1.87v2.87h-0.95v-4.42h1.05l1.16,1.87l1.16-1.87h1.05v4.42
				H302.47z"/>
					</g>
				</g>
				<g>
					<path class="st2" d="M290.45,303.64c-3.79,0-6.61-2.93-6.61-6.62v-0.04c0-3.66,2.76-6.66,6.72-6.66c2.43,0,3.88,0.81,5.08,1.99
			l-1.8,2.08c-0.99-0.9-2.01-1.45-3.29-1.45c-2.17,0-3.74,1.8-3.74,4.01v0.04c0,2.21,1.53,4.05,3.74,4.05
			c1.47,0,2.37-0.59,3.39-1.51l1.8,1.82C294.41,302.75,292.94,303.64,290.45,303.64z"/>
				</g>
			</g>
			<g>
				<path class="st13" d="M301.17,209.71h-22.61c-4.18,0-7.57-3.39-7.57-7.57v-14.41c0-4.18,3.39-7.57,7.57-7.57h22.61
		c4.18,0,7.57,3.39,7.57,7.57v14.41C308.74,206.32,305.35,209.71,301.17,209.71z"/>
				<g>
					<path class="st2" d="M277.37,186.36v3.52h-0.97v-3.52h-1.35v-0.9h3.66v0.9H277.37z" />
					<path class="st2" d="M278.96,189.88v-4.42h3.34v0.87h-2.37v0.9h2.08v0.87h-2.08v0.93h2.4v0.87H278.96z" />
					<path class="st2" d="M284.8,189.96c-1.3,0-2.27-1-2.27-2.27v-0.01c0-1.26,0.95-2.29,2.31-2.29c0.83,0,1.33,0.28,1.74,0.68
			l-0.62,0.71c-0.34-0.31-0.69-0.5-1.13-0.5c-0.75,0-1.28,0.62-1.28,1.38v0.01c0,0.76,0.52,1.39,1.28,1.39
			c0.51,0,0.82-0.2,1.16-0.52l0.62,0.63C286.16,189.66,285.65,189.96,284.8,189.96z"/>
					<path class="st2" d="M289.68,189.88v-1.77h-1.79v1.77h-0.97v-4.42h0.97v1.75h1.79v-1.75h0.97v4.42H289.68z" />
					<path class="st2" d="M294.53,189.88l-0.4-0.99h-1.87l-0.4,0.99h-0.99l1.9-4.45h0.9l1.9,4.45H294.53z M293.19,186.6l-0.59,1.43
			h1.17L293.19,186.6z"/>
					<path class="st2" d="M297.49,189.88h-1.72v-4.42h1.72c1.39,0,2.35,0.95,2.35,2.2v0.01C299.84,188.92,298.88,189.88,297.49,189.88z
			 M298.82,187.67c0-0.78-0.54-1.33-1.33-1.33h-0.75v2.67h0.75c0.8,0,1.33-0.54,1.33-1.32V187.67z"/>
					<path class="st2" d="M302.39,189.96c-1.37,0-2.34-1.02-2.34-2.27v-0.01c0-1.26,0.99-2.29,2.36-2.29c1.36,0,2.34,1.02,2.34,2.27
			v0.01C304.74,188.93,303.75,189.96,302.39,189.96z M303.73,187.67c0-0.76-0.56-1.39-1.34-1.39s-1.33,0.62-1.33,1.38v0.01
			c0,0.76,0.56,1.39,1.34,1.39s1.33-0.62,1.33-1.38V187.67z"/>
				</g>
				<g>
					<path class="st2" d="M289.27,205.37h-5.02v-12.88h5.02c4.05,0,6.85,2.78,6.85,6.4v0.04C296.12,202.56,293.32,205.37,289.27,205.37
			z M293.15,198.93c0-2.28-1.56-3.88-3.88-3.88h-2.19v7.77h2.19c2.32,0,3.88-1.56,3.88-3.85V198.93z"/>
				</g>
			</g>
			<g>
				<path class="st14" d="M201.8,327.74H179.2c-4.18,0-7.57-3.39-7.57-7.57v-14.41c0-4.18,3.39-7.57,7.57-7.57h22.61
		c4.18,0,7.57,3.39,7.57,7.57v14.41C209.37,324.35,205.98,327.74,201.8,327.74z"/>
				<g>
					<path d="M174.02,307.91v-4.01h3.02v0.78h-2.15v0.81h1.89v0.78h-1.89v0.84h2.17v0.78H174.02z" />
					<path d="M179.32,307.98c-1.18,0-2.05-0.91-2.05-2.06v-0.01c0-1.14,0.86-2.07,2.09-2.07c0.76,0,1.21,0.25,1.58,0.62l-0.56,0.65
			c-0.31-0.28-0.62-0.45-1.02-0.45c-0.67,0-1.16,0.56-1.16,1.25v0.01c0,0.69,0.47,1.26,1.16,1.26c0.46,0,0.74-0.18,1.05-0.47
			l0.56,0.57C180.55,307.7,180.09,307.98,179.32,307.98z"/>
					<path d="M183.08,307.98c-1.24,0-2.12-0.92-2.12-2.06v-0.01c0-1.14,0.9-2.07,2.13-2.07s2.12,0.92,2.12,2.06v0.01
			C185.21,307.05,184.31,307.98,183.08,307.98z M184.29,305.91c0-0.69-0.5-1.26-1.21-1.26c-0.71,0-1.2,0.56-1.2,1.25v0.01
			c0,0.69,0.5,1.26,1.21,1.26c0.71,0,1.2-0.56,1.2-1.25V305.91z"/>
					<path d="M188.42,307.91l-1.94-2.55v2.55h-0.87v-4.01h0.81l1.88,2.47v-2.47h0.87v4.01H188.42z" />
					<path d="M191.69,307.98c-1.24,0-2.12-0.92-2.12-2.06v-0.01c0-1.14,0.9-2.07,2.13-2.07s2.12,0.92,2.12,2.06v0.01
			C193.83,307.05,192.93,307.98,191.69,307.98z M192.91,305.91c0-0.69-0.5-1.26-1.21-1.26c-0.71,0-1.2,0.56-1.2,1.25v0.01
			c0,0.69,0.5,1.26,1.21,1.26c0.71,0,1.2-0.56,1.2-1.25V305.91z M191.39,303.59l0.65-1.01l0.75,0.33l-0.73,0.69H191.39z"/>
					<path d="M197.36,307.91v-2.61l-1.13,1.71h-0.02l-1.12-1.69v2.6h-0.86v-4.01h0.95l1.05,1.69l1.05-1.69h0.95v4.01H197.36z" />
					<path d="M198.86,307.91v-4.01h0.88v4.01H198.86z" />
					<path d="M202.21,307.98c-1.18,0-2.05-0.91-2.05-2.06v-0.01c0-1.14,0.86-2.07,2.09-2.07c0.76,0,1.21,0.25,1.58,0.62l-0.56,0.65
			c-0.31-0.28-0.62-0.45-1.02-0.45c-0.67,0-1.16,0.56-1.16,1.25v0.01c0,0.69,0.47,1.26,1.16,1.26c0.46,0,0.74-0.18,1.05-0.47
			l0.56,0.57C203.44,307.7,202.98,307.98,202.21,307.98z"/>
					<path d="M205.97,307.98c-1.24,0-2.12-0.92-2.12-2.06v-0.01c0-1.14,0.9-2.07,2.13-2.07s2.12,0.92,2.12,2.06v0.01
			C208.1,307.05,207.2,307.98,205.97,307.98z M207.18,305.91c0-0.69-0.5-1.26-1.21-1.26c-0.71,0-1.2,0.56-1.2,1.25v0.01
			c0,0.69,0.5,1.26,1.21,1.26c0.71,0,1.2-0.56,1.2-1.25V305.91z"/>
				</g>
				<g>
					<path d="M185.75,323.4v-12.88h9.72v2.52h-6.9v2.61h6.07v2.52h-6.07v2.71h6.99v2.52H185.75z" />
				</g>
			</g>
			<g>
				<path class="st15" d="M201.68,244.3h-22.61c-4.18,0-7.57-3.39-7.57-7.57v-14.41c0-4.18,3.39-7.57,7.57-7.57h22.61
		c4.18,0,7.57,3.39,7.57,7.57v14.41C209.24,240.91,205.86,244.3,201.68,244.3z"/>
				<g>
					<path d="M174.87,224.47v-4.42h3.34v0.87h-2.37v0.9h2.08v0.87h-2.08v0.93h2.4v0.87H174.87z" />
					<path d="M180.26,224.53c-0.67,0-1.35-0.23-1.88-0.71l0.58-0.69c0.4,0.33,0.81,0.54,1.32,0.54c0.4,0,0.64-0.16,0.64-0.42v-0.01
			c0-0.25-0.15-0.37-0.89-0.56c-0.89-0.23-1.47-0.47-1.47-1.35v-0.01c0-0.8,0.64-1.33,1.55-1.33c0.64,0,1.19,0.2,1.64,0.56
			l-0.51,0.73c-0.39-0.27-0.78-0.44-1.15-0.44s-0.57,0.17-0.57,0.39v0.01c0,0.29,0.19,0.39,0.95,0.58c0.9,0.23,1.4,0.56,1.4,1.33
			v0.01C181.89,224.04,181.22,224.53,180.26,224.53z"/>
					<path d="M184.27,220.94v3.52h-0.97v-3.52h-1.35v-0.9h3.66v0.9H184.27z" />
					<path d="M188.72,224.47l-0.4-0.99h-1.87l-0.4,0.99h-0.99l1.9-4.45h0.9l1.9,4.45H188.72z M187.38,221.18l-0.59,1.43h1.17
			L187.38,221.18z"/>
					<path d="M193.05,224.47l-2.14-2.81v2.81h-0.96v-4.42h0.9l2.07,2.72v-2.72h0.96v4.42H193.05z" />
					<path d="M196.26,224.47h-1.72v-4.42h1.72c1.39,0,2.35,0.95,2.35,2.2v0.01C198.61,223.5,197.65,224.47,196.26,224.47z
			 M197.59,222.26c0-0.78-0.54-1.33-1.33-1.33h-0.75v2.67h0.75c0.8,0,1.33-0.54,1.33-1.32V222.26z"/>
					<path d="M202.08,224.47l-0.4-0.99h-1.87l-0.4,0.99h-0.99l1.9-4.45h0.9l1.9,4.45H202.08z M200.74,221.18l-0.59,1.43h1.17
			L200.74,221.18z"/>
					<path d="M205.99,224.47l-0.95-1.42h-0.76v1.42h-0.97v-4.42h2.02c1.04,0,1.67,0.55,1.67,1.46v0.01c0,0.71-0.38,1.16-0.95,1.37
			l1.08,1.58H205.99z M206.01,221.56c0-0.42-0.29-0.63-0.76-0.63h-0.97v1.27h0.99c0.47,0,0.75-0.25,0.75-0.62V221.56z"/>
				</g>
				<g>
					<path d="M188.82,229.65v2.74h6.15v2.58h-6.15v4.99h-2.83v-12.88h9.81v2.58H188.82z" />
				</g>
			</g>
			<g>
				<path class="st16" d="M106.74,315.14H84.13c-4.18,0-7.57-3.39-7.57-7.57v-14.41c0-4.18,3.39-7.57,7.57-7.57h22.61
		c4.18,0,7.57,3.39,7.57,7.57v14.41C114.3,311.75,110.92,315.14,106.74,315.14z"/>
				<g>
					<path d="M79.56,295.09v-4.42h3.34v0.87h-2.37v0.9h2.08v0.87h-2.08v0.93h2.4v0.87H79.56z" />
					<path d="M84.95,295.15c-0.67,0-1.35-0.23-1.88-0.71l0.58-0.69c0.4,0.33,0.81,0.54,1.32,0.54c0.4,0,0.64-0.16,0.64-0.42v-0.01
			c0-0.25-0.15-0.37-0.89-0.56c-0.89-0.23-1.47-0.47-1.47-1.35v-0.01c0-0.8,0.64-1.33,1.55-1.33c0.64,0,1.19,0.2,1.64,0.56
			l-0.51,0.73c-0.39-0.27-0.78-0.44-1.15-0.44s-0.57,0.17-0.57,0.39v0.01c0,0.29,0.19,0.39,0.95,0.58c0.9,0.23,1.4,0.56,1.4,1.33
			v0.01C86.57,294.66,85.9,295.15,84.95,295.15z"/>
					<path d="M88.96,291.56v3.52h-0.97v-3.52h-1.35v-0.9h3.66v0.9H88.96z" />
					<path d="M93.4,295.09l-0.4-0.99h-1.87l-0.4,0.99h-0.99l1.9-4.45h0.9l1.9,4.45H93.4z M92.06,291.8l-0.59,1.43h1.17L92.06,291.8z" />
					<path d="M97.73,295.09l-2.14-2.81v2.81h-0.96v-4.42h0.9l2.07,2.72v-2.72h0.96v4.42H97.73z" />
					<path d="M100.94,295.09h-1.72v-4.42h1.72c1.39,0,2.35,0.95,2.35,2.2v0.01C103.29,294.12,102.33,295.09,100.94,295.09z
			 M102.28,292.87c0-0.78-0.54-1.33-1.33-1.33h-0.75v2.67h0.75c0.8,0,1.33-0.54,1.33-1.32V292.87z"/>
					<path d="M106.76,295.09l-0.4-0.99h-1.87l-0.4,0.99h-0.99l1.9-4.45h0.9l1.9,4.45H106.76z M105.42,291.8l-0.59,1.43h1.17
			L105.42,291.8z"/>
					<path d="M110.68,295.09l-0.95-1.42h-0.76v1.42h-0.97v-4.42h2.02c1.04,0,1.67,0.55,1.67,1.46v0.01c0,0.71-0.38,1.16-0.95,1.37
			l1.08,1.58H110.68z M110.69,292.17c0-0.42-0.29-0.63-0.76-0.63h-0.97v1.27h0.99c0.47,0,0.75-0.25,0.75-0.62V292.17z"/>
				</g>
				<g>
					<path d="M95.94,311.02c-4.01,0-6.77-2.82-6.77-6.62v-0.04c0-3.66,2.85-6.66,6.75-6.66c2.32,0,3.72,0.63,5.06,1.77l-1.78,2.15
			c-0.99-0.83-1.88-1.31-3.37-1.31c-2.06,0-3.7,1.82-3.7,4.01v0.04c0,2.36,1.62,4.09,3.9,4.09c1.03,0,1.95-0.26,2.67-0.77v-1.84
			h-2.85v-2.45h5.59v5.59C100.12,310.1,98.3,311.02,95.94,311.02z"/>
				</g>
			</g>
			<g>
				<path class="st17" d="M106.87,218.89H84.26c-4.18,0-7.57-3.39-7.57-7.57v-14.41c0-4.18,3.39-7.57,7.57-7.57h22.61
		c4.18,0,7.57,3.39,7.57,7.57v14.41C114.44,215.5,111.05,218.89,106.87,218.89z"/>
				<g>
					<path d="M79.55,199.06v-4.42h3.34v0.87h-2.37v0.9h2.08v0.87h-2.08v0.93h2.4v0.87H79.55z" />
					<path d="M84.94,199.12c-0.67,0-1.35-0.23-1.88-0.71l0.58-0.69c0.4,0.33,0.81,0.54,1.32,0.54c0.4,0,0.64-0.16,0.64-0.42v-0.01
			c0-0.25-0.15-0.37-0.89-0.56c-0.89-0.23-1.47-0.47-1.47-1.35v-0.01c0-0.8,0.64-1.33,1.55-1.33c0.64,0,1.19,0.2,1.64,0.56
			l-0.51,0.73c-0.39-0.27-0.78-0.44-1.15-0.44s-0.57,0.17-0.57,0.39v0.01c0,0.29,0.19,0.38,0.95,0.58c0.9,0.23,1.4,0.56,1.4,1.33
			v0.01C86.56,198.63,85.89,199.12,84.94,199.12z"/>
					<path d="M88.95,195.54v3.52h-0.97v-3.52h-1.35v-0.9h3.66v0.9H88.95z" />
					<path d="M93.39,199.06l-0.4-0.99h-1.87l-0.4,0.99h-0.99l1.9-4.45h0.9l1.9,4.45H93.39z M92.05,195.77l-0.59,1.43h1.17L92.05,195.77
			z"/>
					<path d="M97.72,199.06l-2.14-2.81v2.81h-0.96v-4.42h0.9l2.07,2.72v-2.72h0.96v4.42H97.72z" />
					<path d="M100.94,199.06h-1.72v-4.42h1.72c1.39,0,2.35,0.95,2.35,2.2v0.01C103.29,198.09,102.33,199.06,100.94,199.06z
			 M102.27,196.85c0-0.78-0.54-1.33-1.33-1.33h-0.75v2.67h0.75c0.8,0,1.33-0.54,1.33-1.32V196.85z"/>
					<path d="M106.75,199.06l-0.4-0.99h-1.87l-0.4,0.99h-0.99l1.9-4.45h0.9l1.9,4.45H106.75z M105.41,195.77l-0.59,1.43H106
			L105.41,195.77z"/>
					<path d="M110.67,199.06l-0.95-1.42h-0.76v1.42h-0.97v-4.42H110c1.04,0,1.67,0.55,1.67,1.46v0.01c0,0.71-0.38,1.16-0.95,1.37
			l1.08,1.58H110.67z M110.69,196.15c0-0.42-0.29-0.63-0.76-0.63h-0.97v1.27h0.99c0.47,0,0.75-0.25,0.75-0.62V196.15z"/>
				</g>
				<g>
					<path d="M98.15,214.55v-5.17h-5.23v5.17h-2.83v-12.88h2.83v5.1h5.23v-5.1h2.83v12.88H98.15z" />
				</g>
			</g>
			<g>
				<path class="st18" d="M45.05,297.93H22.44c-4.18,0-7.57-3.39-7.57-7.57v-14.41c0-4.18,3.39-7.57,7.57-7.57h22.61
		c4.18,0,7.57,3.39,7.57,7.57v14.41C52.62,294.55,49.23,297.93,45.05,297.93z"/>
				<g>
					<path class="st2" d="M18.25,278.1v-4.42h3.34v0.87h-2.37v0.9h2.08v0.87h-2.08v0.93h2.4v0.87H18.25z" />
					<path class="st2" d="M23.64,278.17c-0.67,0-1.35-0.23-1.88-0.71l0.58-0.69c0.4,0.33,0.81,0.54,1.32,0.54
			c0.4,0,0.64-0.16,0.64-0.42v-0.01c0-0.25-0.15-0.37-0.89-0.56c-0.89-0.23-1.47-0.47-1.47-1.35v-0.01c0-0.8,0.64-1.33,1.55-1.33
			c0.64,0,1.19,0.2,1.64,0.56l-0.51,0.73c-0.39-0.27-0.78-0.44-1.15-0.44s-0.57,0.17-0.57,0.39v0.01c0,0.29,0.19,0.39,0.95,0.58
			c0.9,0.23,1.4,0.56,1.4,1.33v0.01C25.26,277.68,24.59,278.17,23.64,278.17z"/>
					<path class="st2" d="M27.65,274.58v3.52h-0.97v-3.52h-1.35v-0.9H29v0.9H27.65z" />
					<path class="st2" d="M32.09,278.1l-0.4-0.99h-1.87l-0.4,0.99h-0.99l1.9-4.45h0.9l1.9,4.45H32.09z M30.75,274.82l-0.59,1.43h1.17
			L30.75,274.82z"/>
					<path class="st2" d="M36.42,278.1l-2.14-2.81v2.81h-0.96v-4.42h0.9l2.07,2.72v-2.72h0.96v4.42H36.42z" />
					<path class="st2" d="M39.64,278.1h-1.72v-4.42h1.72c1.39,0,2.35,0.95,2.35,2.2v0.01C41.99,277.14,41.03,278.1,39.64,278.1z
			 M40.97,275.89c0-0.78-0.54-1.33-1.33-1.33h-0.75v2.67h0.75c0.8,0,1.33-0.54,1.33-1.32V275.89z"/>
					<path class="st2" d="M45.45,278.1l-0.4-0.99h-1.87l-0.4,0.99h-0.99l1.9-4.45h0.9l1.9,4.45H45.45z M44.11,274.82l-0.59,1.43h1.17
			L44.11,274.82z"/>
					<path class="st2" d="M49.37,278.1l-0.95-1.42h-0.76v1.42h-0.97v-4.42h2.02c1.04,0,1.67,0.55,1.67,1.46v0.01
			c0,0.71-0.38,1.16-0.95,1.37l1.08,1.58H49.37z M49.39,275.19c0-0.42-0.29-0.63-0.76-0.63h-0.97v1.27h0.99
			c0.47,0,0.75-0.25,0.75-0.62V275.19z"/>
				</g>
				<g>
					<path class="st2" d="M32.73,293.78c-2.01,0-3.33-0.88-4.21-1.93l1.79-1.99c0.74,0.81,1.45,1.29,2.36,1.29
			c1.07,0,1.73-0.64,1.73-2.13v-8.3h2.91v8.43C37.29,292.27,35.45,293.78,32.73,293.78z"/>
				</g>
			</g>
		</svg>
	);
};
